/*
 *   查询区高级查询弹出框组件  --wangshhj
 * */
import React, { Component, createRef } from 'react';
import { PubSub } from '@platform/api';
import {
    getSysFieldid,
    toast,
    isFunction,
    isArray,
    isEmpty,
    ajax,
    getAppReqParam,
    getBusinessInfo,
    getGlobalStorage,
} from '@platform/api';
import {
    Dropdown,
    Select as NCSelect,
    Tabs as NCTabs,
    Input as NCFormControl,
    Radio as NCRadio,
    Tooltip as NCTooltip,
    HotKeys as NCHotKeys,
    Tree as NCTree,
    Icon as NCIcon,
    Checkbox as NCCheckbox,
    Button as NCButton,
    Refer,
    Popconfirm,
    MultiLangText as NCMultiLangText,
    RefreshBtn,
} from '@platform/base';
import {
    getTimezoneOffset,
    _clone as deepClone,
    setDefaultScheme,
    tree2Array,
    beSureBtnClick,
    beSureBtnClick_Del,
    spreadQueryPlan,
    _clone,
    setSearchCacheData,
} from './_methods';
import {
    _getAllSearchData,
    delNode,
    setSearchValByFieldHigh as setSearchValByField,
    getCurrentTemplate,
    _addData,
    initData,
    clearAllValue,
    createOperation,
    setMultiLangHigh as setMultiLang,
} from './methods';
import shareTableMeta from './shareTableMeta';

import TipsTitle from './TipsTitle';
import { templateEngine } from './templateEngine';
import { promptBox } from '../PromptBox';
import SortTab from './SortTab';
import { debounce, throttle } from 'lodash';
import SearchItem from './searchItem';
// import ShareSchemaTable from './shareSchemaTable';
import UserAssignContent from './userAssignContent';
// import DutyAssignContent from './dutyAssignContent';
import shareTableData from './shareTableData';
// import TemplateTree from './TemplateTree';
// import toast from '../../api/toast';
// import getSysFieldid from '../../api/getSysFieldid';
require('./searchAdvModal.less');
require('./shareSearchModal.less');
// require('./tree.less');

const NCTabPane = NCTabs.TabPane;
const NCTreeNode = NCTree.TreeNode;
const NCOption = NCSelect.Option;
const NCRadioGroup = NCRadio.RadioGroup;
// 查询区渲染完成发布订阅标识
const BEFORECOMPLETE = 'beforeAreaChangeComplete';
const COMPLETE = 'areaChangeComplete';
const shareTableHeight = 36;

/*
 *   SearchAdvModal组件，props中的参数解释：
 *
 *   moduleId ,                   //查询区组件id
 *	advMeta ,                    //查询区模板
 *	closeModal ,                 //关闭组件方法
 *	searchBtnClick ,             //查询按钮回调
 *	onAfterEvent ,               //编辑后事件
 *   showAdvSearchPlanBtn ,       //是否显示保存方案按钮 ，默认显示
 *   replaceAdvBody ,             //替换高级查询body区域
 *   addAdvTabs ,                 //添加自定义tab页签
 *   addAdvBody ,                 //添加自定义查询条件
 *   replaceRightBody ,           //添加高级查询区右侧区域自定义查询条件Dom (fun)
 *   searchPlanCache ,            //查询方案数据
 *   searchPlanCacheChange ,      //查询方案修改后，回调
 *   oid ,                        // 查询模板的oid
 *   hideSearchCondition = false, // 隐藏候选条件
 *   hideSearchPlan = false       // 隐藏高级查询的查询方案
 *   saveSearchPlan,              // 保存查询方案确定按钮事件 ，用于业务组返回自定义的查询条件
 *   clickPlanEve,                // 点击高级面板中的查询方案事件 ,用于业务组为自定义查询区赋值
 *   advSearchClearEve,           // 高级面板中的清空按钮点击事件回调，用于业务组清除自定义查询条件的值
 * */
export default class SearchAdvCom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: props.searchInfo.status,
            showModal: false, //该参数用来表示高级弹窗是否刚打开
            moveNode: null, // 拖拽节点
            leftTab: props.hideSearchCondition
                ? '2'
                : props.searchInfo.leftTab || '1', // 左侧tab的key值
            currentPlan: {},
            checked: false,
            addChecked: false,
            sortField: [],
            expandedKeys: new Set(['root']),
            foolValue: {},
            value: [],
            searchSchemaTab: '1',
            shareSchemaTab: '1',
            shareTableChecked: false,
            canEditNameId: '-1', //可编辑的行id
            readyShareSchema: [], //待分享的方案
            allocationInfo: [], //分配穿梭框确定后的信息
            //isDefaultPlan:null,
            searchPlanName:{},
            // dragOverIndex: -2,
            searchRight: false,
            selectedRowData: [],
            // searchTablePlanName: '',
            // searchTablePlanMultiName:{},
            // searchPlanMultiName:{}
        };
        this.setStateEve = props.setStateEve;
        this.initByProps(props, true);
        this.containerRef = createRef();
        props.searchInfo.addPlanFun = this.addSearchPlanClick;
        props.searchInfo.savePlanFun = this.saveSearchPlanClick;
        props.searchInfo.handleChangeStatus = this.handleChange;
        props.searchInfo.clearRquiredWraning = this.clearRquiredWraning;

    }

    componentDidMount() {
        if (
            !isFunction(this.props.replaceAdvBody) &&
            !this.props.hideSearchCondition
        ) {
            //每次更新高级查询都更新左侧的内容
            this.createSearchCondition.call(this, this.items);
            // this.createSearchScheme.call(this, this.items); //这里的items应该是其他数据，具体的数据整理在initByProps中
        }

        // this.props._this.getChildrenRefToB &&
        //     this.props._this.getChildrenRefToB(this);
        // 没办法了 只能通过全局订阅发布做了
        this.searchChoosePlan = PubSub.subscribe(
            'searchChoosePlan',
            (msg, data) => {
                console.log(
                    msg,
                    data,
                    'searchChoosePlan只能通过全局订阅发布做了',
                );
                if (data) {
                    let currentPlan =
                        this.props.searchInfo.searchPlanCache.find(
                            item => item.name == data,
                        );
                    if (currentPlan) {
                        this.setState({ currentPlan });
                        this.clickSearchPlan(currentPlan);
                    }
                }
            },
        );

        let shareTableMeta1 = shareTableMeta(this.multiLang);
        const planButtons = [{
            type: 'general_btn',
            key: 'delete',
            title: this.multiLang['page-search-0031'] || '删除',
            area: 'table_row@searchPlanSetting',
        }, {
            type: 'general_btn',
            key: 'share',
            title: this.multiLang['page-search-0124'] || '分享',
            area: 'table_row@searchPlanSetting',
        }, {
            type: 'general_btn',
            key: 'rename',
            title: this.multiLang['page-search-0092'] || '重命名',
            area: 'table_row@searchPlanSetting',
        }];
        const btns = this.props._this._this.button.getButtons();
        const _btns = btns.filter(btn => !planButtons.find(item => item.key === btn.key && item.area === btn.area));

        this.props._this._this.button.setButtons([..._btns, ...planButtons]);

        //该操作列的显示与否是把操作列return null吗
        this.body1_opr = {
            attrcode: 'opr',
            label: [this.multiLang['page-search-0143'] || '操作'],
            itemtype: 'customer',
            fixed: 'right',
            className: 'table-opr',
            visible: true,
            width: 180,
            resizable:false,
            render: (text, record, index) => {
                return record.values.isMyPlan.value ? this.props._this._this.button.createOprationButton(['delete', 'share', 'rename'], {
                    area:'table_row@searchPlanSetting',
                    onButtonClick:(props, id) => {
                        switch(id){
                            case 'share':
                                this.shareSearchSchemaClick(record);
                                break;
                            case 'rename':
                                this.modifySearchMange(text, record, index);
                                if (record && record.rowid) {
                                    this.setState({
                                        canEditNameId: record.rowid,
                                        selectedRowData:record,
                                    });
                                }
                                break;
                            case 'delete':
                                promptBox({
                                    color: 'warning',
                                    hotKeyboard: true,
                                    title: this.multiLang['page-search-0031'],
                                    content: <div>{this.multiLang['page-search-0015']}</div>, // 提示内容,非必输
                                    beSureBtnName: this.multiLang['page-search-0009'], // 确定按钮名称, 默认为"确定",非必输
                                    cancelBtnName: this.multiLang['page-search-0010'],
                                    beSureBtnClick: () => {
                                        if(record.values.pk_ncc_queryscheme){
                                            let preparedPlan = this.props.searchInfo.searchPlanCache.find(item => item.pk_ncc_queryscheme === record.values.pk_ncc_queryscheme.value);
                                            if(preparedPlan && preparedPlan.isprepared){
                                                toast({ content: this.multiLang['page-search-0163'], color: 'warning' });
                                                return;
                                            }
                                        }
        
                                        beSureBtnClick_Del.call(
                                            this.props._this,
                                            false,
                                            record.values.pk_ncc_queryscheme.value,
                                            this,
                                        );
        
                                        this.props.shareTableFunc.delRowsByIndex(
                                            'searchShareTable',
                                            index,
                                        );
                                    },
                                });
                                
                                break;

                        }
                    },
                }) : null;
             
            },
        };
        this.body2_opr = {
            // label: '自定义列',
            attrcode: 'rowdrag',
            key: 'rowdrag',
            width: 40,
            visible: true,
            itemtype: 'customer',
            fixed: 'left',
            columnType: 'rowdrag',
            resizable:false,
            render: (text, record, index) => {
                //record.默认方案&&<span>
                return (
                    !record.values.quick_schema.value &&
                    record.values.pk_ncc_queryscheme.value !== '001' && (
                        <div
                            className="test-opr"
                            draggable={true}
                            pos={index}
                            key={record.rowid}
                            style={{ width: '50px' }}
                            onDragStart={this.onTableDragStart}
                            onDragOver={this.onTableDragOver}
                            // onDragLeave={this.onTableDragLeave}
                            onDragEnd={this.onTableDragEnd}
                            onDrop={this.onTableDrop}
                        >
                            <i
                                className="iconfont icon-tuozhuai1"
                                style={{ fontSize: '16px', cursor:'move' }}
                            ></i>
                        </div>
                    )
                );
            },
        };

        this.body2_xuhao_opr = {
            // label: '自定义列',
            label: [this.multiLang['page-search-0135'] || '序号'],
            attrcode: 'INDEX_CuSTOM',
            key: 'INDEX_CuSTOM',
            width: 60,
            visible: true,
            itemtype: 'customer',
            fixed: 'left',
            columnType: 'INDEX_CuSTOM',
            render: (text, record, index) => {
                //record.默认方案&&<span>
                return ( (
                    <div
                        className="test-opr-index"
                        pos={index}
                        key={record.rowid}
                    >
                        {index + 1}
                    </div>
                )
                );
            },
        };

        // shareTableMeta1.searchShareTable.items.push(this.body2_xuhao_opr);
        shareTableMeta1.searchShareTable.items.push(this.body1_opr);
        shareTableMeta1.searchShareTable.items.push(this.body2_opr);

        this.props.metaFunc.addMeta(shareTableMeta1);

        const formcontrolDoms = document.querySelectorAll('.adv-right-area .search-dom .base-input>input') || [];
        formcontrolDoms.forEach(item => {
            item.addEventListener('mousedown', this.formControlDomsDragstartEvent.bind(this, true));
        });
        document.addEventListener('mouseup', this.formControlDomsDragstartEvent.bind(this, false));
        
    }

    componentWillUnmount() {
        this.props.searchInfo.isRenderAdv = false;
        this.searchChoosePlan && PubSub.unsubscribe(this.searchChoosePlan);
        const formcontrolDoms = document.querySelectorAll('.adv-right-area .search-dom .base-input>input') || [];
        formcontrolDoms.forEach(item => {
            item.removeEventListener('mousedown', this.formControlDomsDragstartEvent.bind(this, true));
        });
        document.removeEventListener('mouseup', this.formControlDomsDragstartEvent.bind(this, false));
    }

    componentWillReceiveProps(props) {
        if (props.onlyShowAdvArea || props.searchInfo.showAdvModal) {
            this.initByProps(props, false);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (!nextProps.onlyShowAdvArea && !nextProps.searchInfo.showAdvModal) {
            return false;
        }
        return true;
    }
    componentDidUpdate() {
        this.props.searchInfo.advSortField = this.state.sortField;
        if (this.props.showAddSearchResult) {
            this.props.searchInfo.addChecked = this.state.addChecked;
        }
        this.props.changePlanEve && this.props.changePlanEve(this.state.currentPlan.isMyPlan);
    }
    formControlDomsDragstartEvent = status => {
        this.mouseDownOnInput = status;
    }

    //flag标识是否第一次初始化
    initByProps = (props, flag) => {
        let searchInfo = props.searchInfo;
        let showModal = this.state.showModal; //false:标识刚打开，true标识已经打开
        let showSortTab =
            (searchInfo.sortField.length > 0 ? true : false);
        let currentPlan, status;
        if (showModal || !props.syncAdvCondition) {
            currentPlan = this.state.currentPlan;
            status = this.state.status;
        } else {
            currentPlan = searchInfo.currentClickPlan || searchInfo.currentPlan; // 当前正在操作的查询方案
            if (Array.isArray(searchInfo.sortField)) {
                this.state.sortField = searchInfo.sortField.map(item => {
                    return { ...item };
                });
            }
            status = searchInfo.status;
            const name123 = searchInfo.multiLangOpt.createName123(currentPlan);
            this.state.searchPlanName = searchInfo.multiLangOpt.getMultiLangValueFromName123(name123);
            //这里要处理多语输入框的初始值，从查询方案中取出来---修改方案名称

            // this.state.searchPlanMultiName = 
            //     {
            //         name1:{value:currentPlan['name']},
            //         name2:{value:(currentPlan['name2'] ? currentPlan['name2'] : currentPlan['name'])},
            //         name3:{value:(currentPlan['name3'] ? currentPlan['name3'] : currentPlan['name'])}
            //     };
            // this.state.searchPlanName = currentPlan.name;
            if (
                props.onlyShowSuperCondition ||
                (currentPlan &&
                    !isEmpty(currentPlan.renderobj4web_snap) &&
                    currentPlan.renderobj4web_snap[0].attrcode == 'root')
            ) {
                status = 'super';
            } else {
                status = 'normal';
            }
        }
        let items = props.meta.items || [];
        this.items = items;
        /* 添加树组件需要的字段 */
        items.forEach(item => {
            if (!item.hasOwnProperty('attrcode')) {
                console.error('查询模板中有字段缺少attrcode字段，请检查');
            }
            if (!item.hasOwnProperty('label')) {
                console.error('查询模板中有字段缺少label字段，请检查');
            }
            item.refpk = item.attrcode;
            item.refname = item.advLable || item.label;
            //item.isleaf = true;
        });
        // 当业务组要替换整个body区域或者不需要候选条件时，不加载候选条件；首次渲染不执行，在componentDidMount中执行
        if (
            !isFunction(props.replaceAdvBody) &&
            !props.hideSearchCondition &&
            !flag
        ) {
            //每次更新高级查询都更新左侧的内容
            this.createSearchCondition.call(this, items);
            // this.createSearchScheme.call(this, this.items); //这里的items应该是其他数据，具体的数据根据模板数据整理
        }

        // 当业务组需要替换整个body区或者替换右侧body区域时，不默认加载右侧
        if (
            !isFunction(props.replaceAdvBody) &&
            !isFunction(props.replaceRightBody)
        ) {
            let isDefaultPlan = currentPlan.pk_ncc_queryscheme == '001';
            let currentSnap = deepClone(currentPlan.renderobj4web_snap);
            let defaultSnap = deepClone(searchInfo.defaultPlan.renderobj4web);

            if (!showModal) {
                this.tabIndex = this.tabIndex || '0';
                if (isFunction(props.addAdvTabs)) {
                    let def = [...props.addAdvTabs()];
                    for (let index = 0; index < def.length; index++) {
                        const element = def[index];
                        element.key = element.key || String(index + 10);
                        if (element.defaultOpen === true) {
                            this.tabIndex = element.key;
                            break;
                        }
                    }
                }
                if (isDefaultPlan) {
                    if (status == 'super' && !props.onlyShowSuperCondition) {
                        searchInfo.snapshotMap.normal = spreadQueryPlan(
                            props.context,
                            defaultSnap,
                            searchInfo.itemsMap,
                            searchInfo.isWidgetMode,
                        );
                        // spreadQueryPlan(props.context, currentSnap, searchInfo.itemsMap);
                        searchInfo.snapshotMap.super = currentSnap;
                    } else if (
                        status == 'super' &&
                        props.onlyShowSuperCondition
                    ) {
                        if (
                            currentSnap &&
                            currentSnap.length &&
                            currentSnap[0].attrcode == 'root'
                        ) {
                            searchInfo.snapshotMap.super = currentSnap;
                        } else {
                            searchInfo.snapshotMap.super = [
                                {
                                    attrcode: 'root',
                                    refpk: 'root',
                                    key: 'root',
                                    operationSign: 'and',
                                    noRemove: true, //不可移除
                                    children: spreadQueryPlan(
                                        props.context,
                                        currentSnap,
                                        searchInfo.itemsMap,
                                        searchInfo.isWidgetMode,
                                    ),
                                    visible: true,
                                },
                            ];
                        }
                    } else {
                        searchInfo.snapshotMap.normal = spreadQueryPlan(
                            props.context,
                            currentSnap,
                            searchInfo.itemsMap,
                            searchInfo.isWidgetMode,
                        );
                        searchInfo.snapshotMap.super = [
                            {
                                attrcode: 'root',
                                refpk: 'root',
                                key: 'root',
                                operationSign: 'and',
                                noRemove: true, //不可移除
                                children: deepClone(
                                    searchInfo.snapshotMap.normal,
                                ),
                                visible: true,
                            },
                        ];
                    }
                } else {
                    if (status == 'super') {
                        if (
                            currentSnap &&
                            currentSnap.length &&
                            currentSnap[0]
                        ) {
                            searchInfo.snapshotMap.super = spreadQueryPlan(
                                props.context,
                                currentSnap,
                                searchInfo.itemsMap,
                                searchInfo.isWidgetMode,
                            );
                        } else {
                            searchInfo.snapshotMap.super = [
                                {
                                    attrcode: 'root',
                                    refpk: 'root',
                                    key: 'root',
                                    operationSign: 'and',
                                    noRemove: true, //不可移除
                                    children: spreadQueryPlan(
                                        props.context,
                                        currentSnap,
                                        searchInfo.itemsMap,
                                        searchInfo.isWidgetMode,
                                    ),
                                    visible: true,
                                },
                            ];
                        }
                        searchInfo.snapshotMap.normal = spreadQueryPlan(
                            props.context,
                            defaultSnap,
                            searchInfo.itemsMap,
                            searchInfo.isWidgetMode,
                        );
                    } else {
                        this.setCacheValue(
                            flag,
                            'super',
                            defaultSnap,
                            searchInfo.snapshotCache,
                        );
                        searchInfo.snapshotMap.normal = spreadQueryPlan(
                            props.context,
                            currentSnap,
                            searchInfo.itemsMap,
                            searchInfo.isWidgetMode,
                        );
                        if(isEmpty(searchInfo.snapshotMap.super)){
                            searchInfo.snapshotMap.super = [
                                {
                                    attrcode: 'root',
                                    refpk: 'root',
                                    key: 'root',
                                    operationSign: 'and',
                                    noRemove: true, //不可移除
                                    children: spreadQueryPlan(
                                        props.context,
                                        defaultSnap,
                                        searchInfo.itemsMap,
                                        searchInfo.isWidgetMode,
                                    ),
                                    visible: true,
                                },
                            ];
                        }
                       
                    }
                }
            } else {
                console.log('gaoji已经打开');
            }
        }
        searchInfo.currentClickPlan = null;
        this.state.showModal = true;
        this.state.currentPlan = currentPlan;
        searchInfo.status = status;
        this.state.status = status;
        searchInfo.advSortField = this.state.sortField;
    };

    /* setState */
    setMyStateEve = callback => {
        this.setState(this.state, callback);
    };

    setCacheValue = (flag, status, defaultSnap, snapshotCache) => {
        if (flag && Array.isArray(defaultSnap)) {
            defaultSnap.forEach(item => {
                if (snapshotCache[status][item?.attrcode]) {
                    item.initialvalue = snapshotCache[status][item.attrcode];
                }
            });
        }
    };

    /* 查询按钮点击事件 */
    searchBtnClickEve = async () => {
        let data = null;
        let template = [];
        const snapshot = this.props.searchInfo.snapshotMap[this.state.status];

        // 如果业务组替换整个body或者右侧body区域，则需要业务组自己组织自定义查询条件
        if (
            isFunction(this.props.replaceRightBody) ||
            isFunction(this.props.replaceAdvBody)
        ) {
            /* 此时查询按钮的回调方法中，data为 'userControl'，表示需要业务组自己处理自定义的查询条件 */
            data = 'userControl';
            if (isFunction(this.props.searchBtnClick)) {
                let f = await this.props.searchBtnClick(
                    {
                        ...this.props._this._this,
                        ...this.props._this._this.props,
                    },
                    data,
                    'super',
                );
                if (!f) {
                    this.props.searchInfo.status = 'simple';
                    this.close(true);
                }
            }
        } else {
            data = _getAllSearchData(
                this.props.searchInfo,
                this.props.context,
                true,
            );
            template = getCurrentTemplate(this.props.searchInfo);
            // NCC-390165 高级查询的高级模式需要先把快照拍平才能拿到正确的模板
            if (this.props.searchInfo.status === 'super') {
                let cloneSearchInfo = deepClone(this.props.searchInfo);
                let snapShot_list = tree2Array(snapshot);
                cloneSearchInfo.snapshotMap['super'] = snapShot_list;
                template = getCurrentTemplate(cloneSearchInfo);
            }
            let ordercondition = this.state.sortField;
            this.props.searchInfo.advSortField = ordercondition;
            if (data !== false) {
                let finalData = {
                    queryAreaCode: this.props.moduleId,
                    oid: this.props.oid || this.props.meta.oid,
                    querytype: 'tree',
                    querycondition: data,
                    template,
                    isAddContent: this.state.addChecked || false,
                    nctz: getTimezoneOffset(),
                    ordercondition: ordercondition.filter(
                        item => item._checked === true,
                    ),
                };
                if (isFunction(this.props.searchBtnClick)) {
                    let clickResult = null;
                    try{
                        clickResult = await this.props.searchBtnClick(
                            {
                                ...this.props._this._this,
                                ...this.props._this._this.props,
                            },
                            data,
                            'super',
                            data && finalData,
                        );
                    }catch(e){
                        console.log(e);
                        clickResult = false;
                    }
    
                    if (!clickResult) {
                        // 点击查询以后存储下当前查询条件 维度是 用户id + appCode + pageCode
                        let pageMeta = this.props._this._this.meta.getMeta();
                        // 存一个变量，如果表格上已经配置了空指引的回调，那就不用去layout里查询了
                        let { clickSearchBtn: clickSearchBtnCallback } =
                            this.props.searchInfo;
                        let tableQuery = false;
                        if (
                            clickSearchBtnCallback &&
                            Array.isArray(clickSearchBtnCallback)
                        ) {
                            tableQuery = clickSearchBtnCallback.some(
                                callback => callback?.tableQuery === true,
                            );
                        }
                        //记录一下查询时候的条件
                        this.props.searchInfo.lastSearchCondition =
                            _clone(data);
                        let addSearchCallback = () => {
                            // 执行智能分析绑定的查询按钮点击事件
                            if (
                                clickSearchBtnCallback &&
                                Array.isArray(clickSearchBtnCallback)
                            ) {
                                clickSearchBtnCallback.forEach(fun => {
                                    typeof fun.callback == 'function' &&
                                        fun.callback(
                                            {
                                                ...this.props._this._this,
                                                ...this.props._this._this.props,
                                            },
                                            data,
                                            'super',
                                            data && finalData,
                                        );
                                });
                            }
                        };
                        setSearchCacheData.call(this.props._this._this, {
                            moduleId: this.props.moduleId,
                            finalData: { ...finalData, snapshot },
                            meta: pageMeta,
                            callback: addSearchCallback,
                            tableQuery,
                        });
                        if (this.props.syncAdvCondition) {
                            this.props.searchInfo.snapshotMap['simple'] =
                                snapshot;
                            this.state.currentPlan.renderobj4web_snap =
                                snapshot;
                            this.props.searchInfo.currentPlan =
                                this.state.currentPlan || {};
                        }
                        this.props.searchInfo.sortField = this.state.sortField;
                        this.close(true);
                    }
                } else {
                    if (this.props.syncAdvCondition) {
                        this.props.searchInfo.snapshotMap['simple'] = snapshot;
                        this.state.currentPlan.renderobj4web_snap = snapshot;
                        this.props.searchInfo.currentPlan =
                            this.state.currentPlan || {};
                    }
                    this.props.searchInfo.sortField = this.state.sortField;
                    this.close(true);
                }
            }
        }
    };

    /* 取消 */
    cancelClick = e => {
        this.props.searchInfo.notFirstOpenAdv = false;
      
        if (e) {
            e.stopPropagation();
        }
        const { backPosition } = this.props;
        isFunction(backPosition) && backPosition();
        if (
            this.props._this._this.state.modal[
                'addSearchPlan@' + this.props.moduleId
            ]?.showModal
        ) {
            this.props.modal.close('addSearchPlan@' + this.props.moduleId);
        } else if (
            this.props._this._this.state.modal[
                'editSearchPlanName@' + this.props.moduleId
            ]?.showModal
        ) {
            this.props.modal.close('editSearchPlanName@' + this.props.moduleId);
        } else if(this.props._this._this.state.modal[
            'editTableSearchName@' + this.props.moduleId
        ]?.showModal){
            this.props.modal.close('editTableSearchName@' + this.props.moduleId);
        }
        else if(this.props._this._this.state.modal[
            'shareTree@' + this.props.moduleId
        ]?.showModal){
            this.props.modal.close('shareTree@' + this.props.moduleId);
        }else if(this.props._this._this.state.modal[
            'shareSearchSchema@' + this.props.moduleId
        ]?.showModal){
            this.props._this._this.state.modal[
                'shareSearchSchema@' + this.props.moduleId
            ]?.showModal;
        }else if(this.props._this._this.state.modal[
            'shareSearchPlan@' + this.props.moduleId
        ]?.showModal){
            this.props.modal.close('shareSearchPlan@' + this.props.moduleId);
        }
        else {
            if (!this.props.hideSearchCondition) {
                this.props.syncTree.setSearchValue(
                    'searchCondition@' + this.props.moduleId,
                );
            }
            this.close();
        }
    };

    /* 保存方案按钮 */
    saveSearchPlanClick = () => {
        beSureBtnClick.call(
            this.props._this,
            'save',
            false,
            this.state.currentPlan,
            this.state.searchPlanName,
            false,
            this.state.sortField,
            this,
            undefined,
        );
    };

    addSearchPlanClickEvent = (status, ke) => {
        if(this.state.searchSchemaTab === '3'){
            this.setState({ searchSchemaTab: '2' });
        }
        beSureBtnClick.call(this.props._this, status, false,this.state.currentPlan, this.planName || this.state.searchPlanName,
            this.state.checked,
            this.state.sortField,
            this,
            ke,
        );
    }

    /* 新增方案按钮 */
    addSearchPlanClick = () => {
        this.state.searchPlanName = {};
        this.planName  ={};
        this.props.modal.show('addSearchPlan@' + this.props.moduleId, {
            cancelBtnClick: () => {
                this.setState({ checked: false });
            },
            closeModalEve: () => {
                this.setState({ checked: false });
            },
            beSureBtnClick:this.addSearchPlanClickEvent.bind(this, 'add'), 
        });
        this.forceUpdate();
    };

    //三数之和为0
    treeNumSum = baseArr => {
        if (baseArr.length < 3) {
            return [];
        }

        let right = baseArr.length - 1;
        let result = [];
        let arr = baseArr.sort((a, b) => {
            return a - b;
        });
        for (let i = 0; i < arr.length - 1; i++) {
            if (arr[i] > 0) {
                break;
            }
            if (i > 0 && arr[i] === arr[i - 1]) {
                continue;
            }
            let left = i + 1;

            while (left < right) {
                if (arr[left] + arr[i] + arr[right] < 0) {
                    left++;
                } else if (arr[left] + arr[i] + arr[right] > 0) {
                    right--;
                } else {
                    result.push([arr[i], arr[left], arr[right]]);
                    while (arr[left] === arr[left + 1]) {
                        left++;
                    }
                    while (arr[right - 1] === arr[right]) {
                        right--;
                    }
                    left++;
                    right--;
                }
            }
        }
        return result;
    };

    // 发送ajax请求
    sendAjax = (url, param, noRenturn) => {
        return new Promise(resolve => {
            ajax({
                async: true,
                url,
                data: param,
                success: res => {
                    if (!res.success) {
                        throw new Error(res.error.message);
                    }
                    if (res.data && res.data.message) {
                        toast({
                            color: 'warning',
                            content: res.data.message,
                        });
                    }
                    if (noRenturn) {
                        if (res.success) {
                            toast({
                                content: this.multiLang['page-search-0119'] || '分享成功',
                                color: 'success',
                            });
                        }
                    } else {
                        resolve(res.data);
                    }
                },
                error: e => {
                    toast({
                        color: e.type || 'danger',
                        content: e.message,
                    });
                },
            });
        });
    };

    /* 共享方案按钮 */
    shareSearchPlanClick = (item, e) => {
        let { shareSchemaTab } = this.state;
        let newCache;
        // let newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
        // ? [...this.props.searchInfo.searchPlanCache]
        // : [];

        //页签不同，分离各自的页签对应的查询方案--全部-我创建的--他人分享的
        //后端返回的数据中应该有区分【我创建的】与【他人分享的】方案的标识
        //难道页签2、3要按照时间排序
        if (shareSchemaTab === '1') {
            newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
                ? [...this.props.searchInfo.searchPlanCache]
                : [];
        } else if (shareSchemaTab === '2') {
            newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
                ? [...this.props.searchInfo.searchPlanCache].filter(
                    e => e.isMyPlan,
                )
                : [];
        } else if (shareSchemaTab === '3') {
            newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
                ? [...this.props.searchInfo.searchPlanCache].filter(
                    e => e.isshared,
                )
                : [];
        }

        // //判断两个字符的组成是否相同
        // let str1 = 'asd',str2 = 'sad';
        // console.log(this.isSameStr(str1,str2));
        // //取两个数组的交集
        // let arr1 = [1,2,2,4], arr2 = [2,3,4];
        // console.log(this.getSameValue(arr1,arr2));
        // //判断一个数是不是快乐数
        // console.log(this.isHappyNumber(19));
        //两数之和
        // console.log(this.twoNumSumIndex(9,[2,3,4,5]));

        // console.log(this.treeNumSum([0,0,0,0]));
        // let shareTableData = this.sendAjax();

        //searchPlanSearch中包含values已展示表格数据
        let newShareTableData = Array.isArray(
            this.props.searchInfo.searchPlanCache,
        )
            ? { rows: [...this.props.searchInfo.searchPlanCache] }
            : { rows: [] };
        //这里的表格数据请求下后端接口吧,还是模板上统一返回，手动过滤渲染页签下的表格
        //这里的数据是不是可以直接通过searchInfo.searchPlanCache来取，参考如下--和查询方案一起返回，返回的数据一致
        //所有查询方案存在props的searchPlanCache中，注意得转换为对应表格数据的形式{rows:[{values:},{},{}]}
        // let newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
        // ? [...this.props.searchInfo.searchPlanCache]
        // : [];
        let shareTableData_new = [];

        //表格中默认勾选的逻辑不能依靠isdefaultdisplay字段，因为这个可能会有n个
        let defaultDisPlay = this.props.meta.defaultDisPlay;
        if (defaultDisPlay === '00000000000000000000') {
            defaultDisPlay = '001';
        }

        newCache.forEach((item, index) => {
            let rowsInfo = { rowid: index, values: {} };
            const name123 = this.props.searchInfo.multiLangOpt.createName123(item);
            rowsInfo['values']['schema_name'] = {};
            rowsInfo['values']['default_schema'] = {};
            rowsInfo['values']['quick_schema'] = {};
            rowsInfo['values']['show_schema'] = {};
            rowsInfo['values']['sharer'] = {};
            rowsInfo['values']['pk_ncc_queryscheme'] = {};
            rowsInfo['values']['pk_queryscheme_user'] = {};
            rowsInfo['values']['isshared'] = {};
            rowsInfo['values']['isMyPlan'] = {};

            rowsInfo['values']['schema_name']['value'] =  this.props.searchInfo.multiLangOpt.getCurrentLanguageValueFromName123(name123)||item.name;;
            rowsInfo['values']['default_schema']['value'] =
                (item.pk_ncc_queryscheme === (defaultDisPlay || this.props.meta.defaultPrepared)) ? true : false;
            rowsInfo['values']['quick_schema']['value'] =
                item.isquickqs || false;
            rowsInfo['values']['show_schema']['value'] = item.visible || item.visible === undefined;
            // rowsInfo['values']['show_schema']['value'] =
            //     item.visible ||
            //     (item.isquickqs || item.isMyPlan || item.visible === undefined
            //         ? true
            //         : false);
            rowsInfo['values']['sharer']['value'] =
                item.user_name ||
                (item.isquickqs || item.isprepared || item.pk_ncc_queryscheme === '001' ? (this.multiLang['page-search-0158'] || '系统') : '');
            rowsInfo['values']['pk_ncc_queryscheme']['value'] =
                item.pk_ncc_queryscheme;
            rowsInfo['values']['pk_queryscheme_user']['value'] =
                item.pk_queryscheme_user;
            rowsInfo['values']['isshared']['value'] = item.isshared;
            rowsInfo['values']['isMyPlan']['value'] = item.isMyPlan;

            shareTableData_new.push(rowsInfo);
        });

        //所有方案中没有默认，则把快速方案的默认置为true
        //最新交互，删除方案后不自动设置默认方案了
        // if (shareSchemaTab === '1'){
        //     let hasDefaultFlag;
        //     shareTableData_new.forEach(e =>{
        //         if(e.values.default_schema.value === true){
        //             hasDefaultFlag=true
        //         }
        //     });
        //     if(!hasDefaultFlag && shareTableData_new[1]){
        //         shareTableData_new[1].values.default_schema.value = true;
        //     }
        // }

        let shareTableData_newObj = { rows: shareTableData_new };

        this.props.shareTableFunc.setTableData(
            'searchShareTable',
            shareTableData_newObj,
        );

        // this.props.shareTableFunc.setTableData(
        //     'searchShareTable',
        //     shareTableData()
        // );

        //默认方案对应的显示方案置灰
        let curTableData =
            this.props.shareTableFunc.getAllData('searchShareTable').rows;
        curTableData.forEach((e, i) => {
            this.props.shareTableFunc.setEditableByIndex(
                'searchShareTable',
                i,
                'show_schema',
                true,
            );
        });
        curTableData.forEach((e, i) => {
            if (
                (e.values.default_schema && e.values.default_schema.value) ||
                (e.values.quick_schema && e.values.quick_schema.value) ||
                (e.values.pk_ncc_queryscheme &&
                    e.values.pk_ncc_queryscheme.value === '001')
            ) {
                this.props.shareTableFunc.setEditableByIndex(
                    'searchShareTable',
                    i,
                    'show_schema',
                    false,
                );
            }
        });

        //因为默认全部页签下不显示表格操作列
        if (shareSchemaTab != '3') {
            this.props.shareTableFunc.showColByKey('searchShareTable', ['opr']);
        } else {
            this.props.shareTableFunc.hideColByKey('searchShareTable', ['opr']);
        }

        //我创建的页签不显示分享人字段
        if (shareSchemaTab != '2') {
            this.props.shareTableFunc.showColByKey('searchShareTable', ['sharer']);
        } else {
            this.props.shareTableFunc.hideColByKey('searchShareTable', ['sharer']);
        }

        if (shareSchemaTab === '1') {
            this.props.shareTableFunc.showColByKey('searchShareTable', [
                'rowdrag',
            ]);
        } else {
            this.props.shareTableFunc.hideColByKey('searchShareTable', [
                'rowdrag',
            ]);
        }
        this.props.shareTableFunc.setStatus('searchShareTable', 'edit');

        //设置表格的前两行拖拽不可编辑
        // [0,1].forEach(item => {
        //     this.props.shareTableFunc.setEditableByIndex(
        //         'searchShareTable',
        //         item,
        //         'rowdrag',
        //         false
        //     );
        // })

        this.props.modal.show('shareSearchPlan@' + this.props.moduleId);
        this.forceUpdate();
    };
    /* 查询方案共享按钮 */
    shareSearchSchemaClick = (item, e) => {
        //储存传递过来的待分享方案，在树树穿梭框点击确定按钮时，返回给后端处理
        this.setState({ readyShareSchema: item });
        this.props.modal.show('shareSearchSchema@' + this.props.moduleId);
        this.forceUpdate();
    };

    //树穿梭弹窗
    shareTransFerClick = (item, e) => {
        //储存传递过来的待分享方案，在树树穿梭框点击确定按钮时，返回给后端处理
        this.setState({ readyShareSchema: item });
        this.props.modal.show('shareTree@' + this.props.moduleId);
        this.forceUpdate();
    };

    /**
     * 根据父级pk获取子节点pk
     * @param {*} parentPk
     * @param {*} includeParentPk
     */
    getChildrenPk = (treeData, parentPk, includeParentPk = false) => {
        let allPks = includeParentPk
            ? Array.isArray(parentPk)
                ? parentPk
                : [parentPk]
            : [];
        const loopData = data => {
            for (let i = 0; i < data.length; i++) {
                let { refpk, key, children } = data[i];
                let pk = refpk || key;
                allPks.push(pk);
                if (Array.isArray(children)) {
                    loopData(children);
                }
            }
        };
        const parentNode = this.getItem(treeData, parentPk) || {};
        loopData(parentNode.children || []);
        return allPks;
    };

    /* 根据key获取子树 */
    getItem = (treeData, key) => {
        if (!key) {
            return treeData;
        }
        let length = treeData.length;
        for (let i = 0; i < length; i++) {
            let item = treeData[i];
            if (item.key == key || item.refpk == key) {
                return item;
            } else if (Array.isArray(item.children)) {
                let res = this.getItem(item.children, key);
                if (res) {
                    return res;
                }
            }
        }
    };

    //保存分享方案
    saveSchemeShare = () => {
        let { readyShareSchema } = this.state;
        //如果是左栏那直接分享的话，readyShareSchema的样式要改一下

        //查询方案主键pk_ncc_queryscheme
        // let pk_ncc_queryscheme =readyShareSchema.pk_ncc_queryscheme.value;
        //appcode-pagecode
        let businessInfo = getBusinessInfo();
        console.log(businessInfo);

        let groupId = businessInfo.groupId || [];
        // let groupTarget = [];
        // groupVOs.forEach(item => {
        //     if(item.is_selected){
        //         groupTarget.push(item.pk_group)
        //     }
        // });

        let appReqParam = getAppReqParam();
        let appcode = appReqParam.appcode;
        let pagecode = appReqParam.pagecode;
        if(this.props.customAppCode && this.props.customPageCode){
            appcode = this.props.customAppCode;
            pagecode = this.props.customPageCode;
        }
        let url = '/nccloud/platform/templet/saveSchemeShare.do';
        let noRenturn = true;
        let param = [];
        let checkedSharetarget = this.props.syncTree.getTreeToList(
            'transferRight@' + this.props.moduleId,
        );
        let needToDeleteKeys = [];

        //点确定的时候，取之前右树的数据，然后判断出哪些需要删除的数据pk
        // for(let i=0;i<needToDeleteKeys.length;i++){
        //     if(needToDeleteKeys.refpk )
        // }

        if (
            checkedSharetarget.length === 0 &&
            !this.Child.state.transferDisabled
        ) {
            param.push({
                pk_ncc_queryscheme:
                readyShareSchema.values ? readyShareSchema.values.pk_ncc_queryscheme.value : readyShareSchema.pk_ncc_queryscheme,
                targettype: 5,
                appcode,
                pagecode,
                pk_queryscheme_share:
                readyShareSchema.values ? readyShareSchema.values.pk_queryscheme_share?.value : readyShareSchema.pk_queryscheme_share,
            });
        } else {
            if (this.Child.state.transferDisabled) {
                //集团级共享的true/false
                //通过this.Child获取'集团级共享'的状态，再去请求接口
                if (Array.isArray(readyShareSchema)) {
                    // readyShareSchema.forEach(item => {
                    //     param.push({pk_ncc_queryscheme:item.values.pk_ncc_queryscheme.value,targettype:5,appcode,targetid:groupTarget,pagecode,pk_queryscheme_share:item.values.pk_queryscheme_share?.value});
                    // });
                    for (let i = 0; i < readyShareSchema.length; i++) {
                        param.push({
                            pk_ncc_queryscheme:
                                readyShareSchema[i].data.values.pk_ncc_queryscheme
                                    .value,
                            targettype: 5,
                            appcode,
                            targetid: groupId,
                            pagecode,
                            pk_queryscheme_share:
                                readyShareSchema[i].data.values.pk_queryscheme_share
                                    ?.value,
                        });
                    }
                } else {
                    param.push({
                        pk_ncc_queryscheme:
                        readyShareSchema.values ? readyShareSchema.values.pk_ncc_queryscheme.value : readyShareSchema.pk_ncc_queryscheme,
                        targettype: 5,
                        appcode,
                        targetid: groupId,
                        pagecode,
                        pk_queryscheme_share:
                        readyShareSchema.values ? readyShareSchema.values?.pk_queryscheme_share
                            ?.value : readyShareSchema.values,
                    });

                    // for(let j=0;j<groupTarget.length;j++){
                    //     param.push({pk_ncc_queryscheme:readyShareSchema.values.pk_ncc_queryscheme.value,targettype:5,appcode,targetid:groupTarget[j],pagecode,pk_queryscheme_share:readyShareSchema.values.pk_queryscheme_share?.value});
                    // }
                }
            } else {
                //分享对象信息--右树已选值的refpk
                //树树穿梭框点击确定时，把已选的方案与分配谁更新state中的allocationInfo
                //如果是在表格中点击的分享，弹出树树穿梭框后，点确定后保存分配信息，点击表格的确定后再请求接口
                let treeRightData = this.props.syncTree.getTreeData(
                    'transferRight@' + this.props.moduleId,
                );
                let tabPks = ['user', 'role', 'org', 'dept'];
                let targetTypes = { user: 1, role: 2, org: 3, dept: 4 };

                if (Array.isArray(readyShareSchema)) {
                    readyShareSchema.forEach(iten => {
                        tabPks.forEach(e => {
                            let checkTabRightKeys = this.getChildrenPk(
                                treeRightData,
                                e,
                            );
                            checkTabRightKeys.forEach(item => {
                                if (!tabPks.includes(item)) {
                                    let currentNodeInfo = this.props.syncTree.getItem(checkedSharetarget, item);
                                    param.push({
                                        pk_ncc_queryscheme:
                                            iten.data.values.pk_ncc_queryscheme
                                                .value,
                                        targettype: targetTypes[e],
                                        appcode,
                                        pagecode,
                                        targetid: currentNodeInfo.isleaf ? currentNodeInfo.oldrefpk : currentNodeInfo.refpk,
                                        pk_queryscheme_share:
                                            iten.data.values
                                                .pk_queryscheme_share?.value,
                                    });
                                }
                            });
                        });
                    });
                } else {
                    tabPks.forEach(e => {
                        let checkTabRightKeys = this.getChildrenPk(
                            treeRightData,
                            e,
                        );
                        checkTabRightKeys.forEach(item => {
                            if (!tabPks.includes(item)) {
                                let currentNodeInfo = this.props.syncTree.getItem(checkedSharetarget, item);
                                param.push({
                                    pk_ncc_queryscheme:
                                    readyShareSchema.values ? readyShareSchema.values
                                        .pk_ncc_queryscheme.value : readyShareSchema.pk_ncc_queryscheme,
                                    targettype: targetTypes[e],
                                    appcode,
                                    pagecode,
                                    targetid: currentNodeInfo.isleaf ? currentNodeInfo.oldrefpk : currentNodeInfo.refpk,
                                });
                            }
                        });
                    });
                }
            }
        }

        //组织接口请求参数
        // let param = {pk_ncc_queryscheme,appcode,pagecode}

        this.sendAjax(url, param, noRenturn);
    };

    /* 用户分配按钮 */
    userAssignClick = () => {
        this.props.modal.show('userAssign@' + this.props.moduleId);
        this.forceUpdate();
    };
    /* 职责分配按钮 */
    dutyAssignClick = () => {
        this.props.modal.show('dutyAssign@' + this.props.moduleId);
        this.forceUpdate();
    };
    modifySearchMange = (text, record, index) => {
        //若要达到某单元格可编辑，把表格置为可编辑，但所有列disabled，点击重命名后把某个单元格设置为可编辑
        // this.props.shareTableFunc.setEditableByIndex('searchShareTable', index, 'schema_name', false);
        //上来设置浏览态，点击了重命名后放开方案名称的编辑前

        //在弹窗中进行重命名
        // this.clickSearchPlan(item);
        // this.props.modal.show('editTableSearchName@' + this.props.moduleId);

        let showInTable = true;
        this.planName =this.state.searchPlanName;
        this.props.modal.show('editTableSearchName@' + this.props.moduleId, {
            beSureBtnClick: () => {
                let params = this.state.selectedRowData;
                //取当前已选数据
                let currentPlan = this.props.searchInfo.searchPlanCache.find(
                    item =>
                        item.pk_ncc_queryscheme === params.values.pk_ncc_queryscheme.value,
                );
                beSureBtnClick.call(
                    this.props._this,
                    'edit',
                    false,
                    currentPlan,
                    this.planName,
                    this.state.checked,
                    this.state.sortField,
                    this,
                    undefined,
                    null,
                    showInTable,
                );
                this.state.selectedRowData = [];
                const currentName = this.props.searchInfo.multiLangOpt.getCurrentLanguageValueFromMultiLangValue(this.planName);
                if( currentName !== ''){
                    this.props.shareTableFunc.setValByKeyAndIndex(
                        'searchShareTable',
                        params.values.numberindex.value - 1,
                        'schema_name',
                        { display:currentName, value:currentName },
                    );
                }
            },
            cancelBtnClick: () => {
                this.state.selectedRowData = [];
                this.forceUpdate();
            },
        });

        let curClickTableSchema = this.props.searchPlanCache.find(item => {
            return item.pk_ncc_queryscheme === record.values.pk_ncc_queryscheme.value;
        });
        const name123 = this.props.searchInfo.multiLangOpt.createName123(curClickTableSchema);
        const searchPlanName = this.props.searchInfo.multiLangOpt.getMultiLangValueFromName123(name123);

        this.setState({ searchPlanName });
        this.forceUpdate();
    };
    saveSearchMange = () => {
        this.props.shareTableFunc.setStatus('searchShareTable', 'browse');
    };
    deleteSearchMange = () => {
        promptBox({
            color: 'warning',
            zIndex: this.props.zIndex+60,
            hotKeyboard: true,
            title: this.multiLang['page-search-0031'],
            content: <div>{this.multiLang['page-search-0154']}</div>, // 提示内容,非必输
            beSureBtnName: this.multiLang['page-search-0009'], // 确定按钮名称, 默认为"确定",非必输
            cancelBtnName: this.multiLang['page-search-0010'],
            beSureBtnClick: () => {
                let selData = this.props.shareTableFunc.getCheckedRows('searchShareTable');

                let pk_ncc_queryschemes = [];
        
                console.log('删除表格行'); //获取选项中行的index
        
                console.log('获取选中行数据：', selData);
                selData.forEach(item => {
                    pk_ncc_queryschemes.push(item.data.values.pk_ncc_queryscheme.value);
                });
                //如果是预置方案，不执行删除，toast提示
                let preparedPlan = this.props.searchInfo.searchPlanCache.filter(item => pk_ncc_queryschemes.includes(item.pk_ncc_queryscheme) && item.isprepared );

                if(preparedPlan && preparedPlan.length > 0){
                    toast({ content: multiLang['page-search-0163'], color: 'warning' });
                    return;
                }

                selData.forEach(item => {   
                    this.props.shareTableFunc.delRowByRowId(
                        'searchShareTable',
                        item.data.rowid,
                    );
                });
        
                beSureBtnClick_Del.call(
                    this.props._this,
                    false,
                    pk_ncc_queryschemes,
                    this,
                );
            },
        });

    };

    //进行批量分享校验
    checkBatchShare = async () => {};

    batchSearchMange = (checkedSchema, sharedSchemaPks) => {
        //1.首先获取已选的表格数据
        //2.判断已选数据中是否有已经有分享出去的方案
        //3.若有，则显示下面的提示框；否则，直接跳转树树穿梭框页面
        //4.若已显示提示框，点击确定的时候，跳转至树树穿梭框页面
        // let curCheckedRows =
        //     this.props.shareTableFunc.getCheckedRows('searchShareTable');
        // console.log(curCheckedRows);

        // let showModalFalg = curCheckedRows.some((e) => {
        //     return e.data.dataIndex === 1;
        // });

        //根据已分享方案的主键pk找出已分享方案的名称
        let hasSharedSchemaName = [];
        let joinedName;
        let joinedNewName = '';
        if (sharedSchemaPks.length > 0) {
            this.props.searchPlanCache.forEach(e => {
                if (sharedSchemaPks.includes(e.pk_ncc_queryscheme)) {
                    hasSharedSchemaName.push(e.name);
                    joinedNewName += ` 【${e.name}】`;
                }
            });
            joinedNewName += ' ';
            joinedName = hasSharedSchemaName.join('/');
        }

        //

        if (sharedSchemaPks.length > 0) {
            console.log('查询方案批量分享');
            //重写点击确定之后的方法，让其打开分享弹窗
            promptBox({
                color: 'warning',
                zIndex: 313,
                hotKeyboard: true,
                title: this.multiLang['page-search-0120'],
                content: (
                    <div>
                        {this.multiLang['page-search-0165']?.replace('{0}', joinedNewName)}
                    </div>
                ), // 提示内容,非必输
                beSureBtnName: this.multiLang['page-search-0089'], // 确定按钮名称, 默认为"确定",非必输
                cancelBtnName: this.multiLang['page-search-0090'],
                beSureBtnClick: () => {
                    //这个估计得把当前行数据record带过去
                    this.setState({ searchRight: true });
                    this.shareSearchSchemaClick(checkedSchema);

                    //点击多个查询方案进行批量共享的时候，点击确定右树不需要调接口，直接是空的
                },
            });
        } else {
            //这个估计得把当前行数据record带过去
            this.setState({ searchRight: true });
            this.shareSearchSchemaClick(checkedSchema);
        }
    };
    /* 关闭模态框 */
    close = flag => {
        const { onlyShowModalCancelCallback, onlyShowModal } = this.props;
        let statusChangeEvent = this.props.statusChangeEvent;
        statusChangeEvent && statusChangeEvent('simple');
        !flag &&
            onlyShowModal &&
            isFunction(onlyShowModalCancelCallback) &&
            onlyShowModalCancelCallback();
        this.props.searchInfo.status = 'simple';
        PubSub.publishSync(BEFORECOMPLETE, true);
        this.props._this._this.infoExchangeController.publishSync(
            'heightChange',
            { area: 'searchArea', target: this.containerRef.current },
        );
        this.setState({ showModal: false }, () => {
            this.props._this._this.infoExchangeController.publishSync(
                'heightChange',
                { area: 'searchArea', target: this.containerRef.current },
            );
            // 发布通知表格更新高度
            PubSub.publish(COMPLETE, true);
        });
        document.body.style.overflow = 'auto';
        if ( this.props.activeElement){
            setTimeout(()=>{
                this.props.activeElement.focus();
                this.props.activeElement = null
            },100)

         }
        this.props.closeModal(flag);
    };

    /* 字段操作符change事件 */
    mathSignChange = (data, val, oldValue) => {
        if (
            val !== 'between' &&
            val !== 'not between' &&
            (oldValue === 'between' || oldValue === 'not between')
        ) {
            data.initialvalue.value = '';
            data.initialvalue.display = '';
        } else if (
            (val === 'between' || val === 'not between') &&
            oldValue !== 'between' &&
            oldValue !== 'not between'
        ) {
            data.initialvalue.display = [];
            data.initialvalue.value = [];
        }
        data.operationSign = val;
        this.setStateEve(() => {
            typeof this.props.onOperateTypeChange === 'function' &&
                this.props.onOperateTypeChange(data.attrcode, val);
        });
    };

    /* 拖拽到节点 */
    onDropChildren = e => {
        e.preventDefault();
        const keys = JSON.parse(e.currentTarget.getAttribute('keys'));
        this.state.targetKey = keys.attrcode;
        this.state.targetIsExtend = keys.isExtend;
    };

    /* 父节点操作符change事件 */
    logicSelectChange = (data, val, oldval) => {
        if (data.attrcode === 'root' && data.attrcode === 'root') {
            data.operationSign = val;
            this.forceUpdate();
        } else {
            setSearchValByField.call(
                this.props._this._this,
                this.props.moduleId,
                data.refpk,
                data,
                val,
            );
        }
    };

    /* 左侧tab ，change事件 */
    tabChange = val => {
        this.setState({ leftTab: val });
    };

    tabSearchSchemaChange = val => {
        this.setState({ searchSchemaTab: val });
    };

    tabShareSchemaChange = val => {
        // if(val == '3'){
        //     let shareTableMeta1 = shareTableMeta();
        //     this.props.metaFunc.addMeta(shareTableMeta1);
        // }

        let newCache;
        // let newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
        // ? [...this.props.searchInfo.searchPlanCache]
        // : [];

        //页签不同，分离各自的页签对应的查询方案--全部-我创建的--他人分享的
        //后端返回的数据中应该有区分【我创建的】与【他人分享的】方案的标识
        if (val === '1') {
            newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
                ? [...this.props.searchInfo.searchPlanCache]
                : [];
        } else if (val === '2') {
            newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
                ? [...this.props.searchInfo.searchPlanCache].filter(
                    e => e.isMyPlan,
                )
                : [];
        } else if (val === '3') {
            newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
                ? [...this.props.searchInfo.searchPlanCache].filter(
                    e => e.isshared,
                )
                : [];
        }

        if (val == '3') {
            this.props.shareTableFunc.hideColByKey('searchShareTable', ['opr']);
        } else {
            this.props.shareTableFunc.showColByKey('searchShareTable', ['opr']);
        }

        //我创建的页签不显示分享人字段
        if (val != '2') {
            this.props.shareTableFunc.showColByKey('searchShareTable', ['sharer']);
        } else {
            this.props.shareTableFunc.hideColByKey('searchShareTable', ['sharer']);
        }

        if (val === '1') {
            this.props.shareTableFunc.showColByKey('searchShareTable', [
                'rowdrag',
            ]);
        } else {
            this.props.shareTableFunc.hideColByKey('searchShareTable', [
                'rowdrag',
            ]);
        }

        this.setState({ shareSchemaTab: val });
        //这里的表格数据请求下后端接口吧
        //不同的页签加载不同的表格数据
        //这里默认方案与快速查询的分享人如果没有就返回当前集团系统

        let shareTableData_new = [];
        //表格中默认勾选的逻辑不能依靠isdefaultdisplay字段，因为这个可能会有n个
        let defaultDisPlay = this.props.meta.defaultDisPlay;
        if (defaultDisPlay === '00000000000000000000') {
            defaultDisPlay = '001';
        }
        newCache.forEach((item, index) => {
            let rowsInfo = { rowid: index, values: {} };
            const name123 = this.props.searchInfo.multiLangOpt.createName123(item);
            rowsInfo['values']['schema_name'] = {};
            rowsInfo['values']['default_schema'] = {};
            rowsInfo['values']['quick_schema'] = {};
            rowsInfo['values']['show_schema'] = {};
            rowsInfo['values']['sharer'] = {};
            rowsInfo['values']['pk_ncc_queryscheme'] = {};
            rowsInfo['values']['pk_queryscheme_user'] = {};
            rowsInfo['values']['isshared'] = {};
            rowsInfo['values']['isMyPlan'] = {};

            rowsInfo['values']['schema_name']['value'] = this.props.searchInfo.multiLangOpt.getCurrentLanguageValueFromName123(name123)||item.name;
            rowsInfo['values']['default_schema']['value'] =
                (item.pk_ncc_queryscheme === (defaultDisPlay || this.props.meta.defaultPrepared)) ? true : false;
            rowsInfo['values']['quick_schema']['value'] =
                item.isquickqs || false;
            rowsInfo['values']['show_schema']['value'] = item.visible || item.visible === undefined;
            // rowsInfo['values']['show_schema']['value'] = 
            //     item.visible ||
            //     (item.isquickqs || item.isMyPlan || item.visible === undefined
            //         ? true
            //         : false);
            rowsInfo['values']['sharer']['value'] =
                item.user_name ||
                (item.isquickqs || item.isprepared || item.pk_ncc_queryscheme === '001' ? (this.multiLang['page-search-0158'] || '系统') : '');
            rowsInfo['values']['pk_ncc_queryscheme']['value'] =
                item.pk_ncc_queryscheme;
            rowsInfo['values']['pk_queryscheme_user']['value'] =
                item.pk_queryscheme_user;
            rowsInfo['values']['isshared']['value'] = item.isshared;
            rowsInfo['values']['isMyPlan']['value'] = item.isMyPlan;

            shareTableData_new.push(rowsInfo);
        });

        //所有方案中没有默认，则把快速方案的默认置为true
        //最新交互，删除方案后不自动设置默认方案了
        // if (val === '1'){
        //     let hasDefaultFlag;
        //     shareTableData_new.forEach(e =>{
        //         if(e.values.default_schema.value === true){
        //             hasDefaultFlag=true
        //         }
        //     });
        //     if(!hasDefaultFlag  && shareTableData_new[1]){
        //         shareTableData_new[1].values.default_schema.value = true;
        //     }
        // }

        let shareTableData_newObj = { rows: shareTableData_new };

        this.props.shareTableFunc.setTableData(
            'searchShareTable',
            shareTableData_newObj,
        );

        //显示方案置灰
        let curTableData =
            this.props.shareTableFunc.getAllData('searchShareTable').rows;
        curTableData.forEach((e, i) => {
            this.props.shareTableFunc.setEditableByIndex(
                'searchShareTable',
                i,
                'show_schema',
                true,
            );
        });
        curTableData.forEach((e, i) => {
            if (
                (e.values.default_schema && e.values.default_schema.value) ||
                (e.values.quick_schema && e.values.quick_schema.value) ||
                (e.values.pk_ncc_queryscheme &&
                    e.values.pk_ncc_queryscheme.value === '001')
            ) {
                this.props.shareTableFunc.setEditableByIndex(
                    'searchShareTable',
                    i,
                    'show_schema',
                    false,
                );
            }
        });

        // this.props.shareTableFunc.setTableData(
        //     'searchShareTable',
        //     shareTableData()
        // );
    };

    /* 创建左侧查询条件区域 */
    createSearchCondition = items => {
        //去掉固定条件和模板不显示的项
        //items是模板上的查询区各项，第二个树数据应该也是模板获取数据后拼接
        let cloneItems = _clone(items);
       
        let _item = cloneItems.filter(item => {
            item.disabled = false;
            if (item.message) {
                item.customerIconRender = () => (
                    <NCTooltip
                        delayShow={800}
                        // delayHide={1}
                        inverse
                        overlay={item.message}
                        placement="top"
                    >
                        <span className="NC_iconBox tooltip-icon">
                            <i className="iconfont icon-shuoming1 icon-msg-unhover" />
                            <i className="iconfont icon-shuoming2 icon-msg-hover " />

                        </span>
                    </NCTooltip>
                );
            }
            return item.isfixedcondition != true && item.iscondition !== false;
        });
        let tree = this.props.syncTree.createTreeData(_item);
        this.props.syncTree.setSyncTreeData(
            'searchCondition@' + this.props.moduleId,
            tree,
            null,
            false,
            { noResetExpandedKeys: true },
        );
    };

    /* 创建左侧查询方案区域 */
    createSearchScheme = items => {
        //---------------查询方案
        let newCache = Array.isArray(this.props.searchInfo.searchPlanCache)
            ? [...this.props.searchInfo.searchPlanCache]
            : [];

        //去掉固定条件和模板不显示的项
        let cloneItems = _clone(newCache);
        //通过isleaf与pid属性，可完成对应的树展示形式
        // cloneItems[cloneItems.length - 1]['pid'] = '001';
        // cloneItems[cloneItems.length - 1]['isleaf'] = true;
        // cloneItems[cloneItems.length - 2]['isleaf'] = false;

        cloneItems.unshift({
            refpk: 'shareglobal',
            attrcode: 'shareglobal',
            refname: '全局级',
            label: '全局级',
            isleaf: false,
            pid: 'shareroot',
        });
        cloneItems.unshift({
            refpk: 'shareclique',
            attrcode: 'shareclique',
            refname: '集团级',
            label: '集团级',
            isleaf: false,
            pid: 'shareroot',
        });
        cloneItems.unshift({
            refpk: 'personal',
            attrcode: 'personal',
            refname: '个人方案',
            label: '个人方案',
            isleaf: false,
        });
        cloneItems.unshift({
            refpk: 'shareroot',
            attrcode: 'shareroot',
            refname: '共享方案',
            label: '共享方案',
            isleaf: false,
        });

        cloneItems.forEach((item, key) => {
            if (key > 3) {
                if (item.isleaf === undefined) {
                    item['customerIcons'] = [
                        { icon: 'gerenpeizhi', title: '重命名' },
                        { icon: 'shanchu', title: '删除' },
                        { icon: 'sheweimoren', title: '设为默认' },
                    ];
                    item['attrcode'] = item['pk_ncc_queryscheme'];
                    item['refpk'] = item['pk_ncc_queryscheme'];
                    item['refname'] = item['name'];
                    item['label'] = item['name'];
                    item['pid'] = 'shareglobal';
                    item['visible'] = true;
                } else {
                    item['customerIcons'] = [
                        { icon: 'zengjia', title: '增加' },
                    ];
                    item['attrcode'] = item['pk_ncc_queryscheme'];
                    item['refpk'] = item['pk_ncc_queryscheme'];
                    item['refname'] = item['name'];
                    item['label'] = item['name'];
                    item['visible'] = true;
                }
            }
        });
        let _item = cloneItems.filter(item => {
            if (item.message) {
                item.customerIconRender = () => (
                    <NCTooltip
                        delayShow={800}
                        // delayHide={1}
                        inverse
                        overlay={item.message}
                        placement="rightTop"
                    >
                        <span className="NC_iconBox tooltip-icon">
                            <i className={'iconfont icon-wenhao-m'} />
                        </span>
                    </NCTooltip>
                );
            }
            return item.isfixedcondition != true;
        });
        let tree = this.props.syncTree.createTreeData(cloneItems);
        this.props.syncTree.setSyncTreeData(
            'searchSchema@' + this.props.moduleId,
            tree,
            // null,
            // false,
            // { noResetExpandedKeys: true }
        );
    };

    //单击箭头添加查询条件
    clickRight = (event, node) => {
        // this.onDrop('clickRight', node);
        let target = node.attrcode;
        this.onDoubleClick(target);
    };

    onClickRight = debounce(this.clickRight, 200);

    /* 拖到普通查询的区域 */
    onDrop = (flag, node) => {
        // console.log(flag, node);
        if (typeof flag === 'string' && this.state.status === 'super') {
            return;
        }
        //点箭头
        if (flag === 'clickRight') {
            this.state.moveNode = deepClone(node);
        } else if (typeof flag === 'string') {
            //双击
            this.state.moveNode = this.props.searchInfo.itemsMap[flag];
        } else {
            // 拖拽
            this.state.moveNode = deepClone(
                this.props.syncTree.getMoveNodeKey(
                    'searchCondition@' + this.props.moduleId,
                ),
            );
        }
        // console.log(this.state.moveNode, '111111111111111111111111');
        //如果拖拽的节点是数组并且第一项的isdrag为false或者 节点为对象并且isdrag 为false，不允许拖拽
        if (
            (isArray(this.state.moveNode) &&
                this.state.moveNode[0].isdrag === false) ||
            this.state.moveNode.isdrag === false
        ) {
            return;
        }
        if (this.state.moveNode.onlyOne === true) {
            //平铺方案，有过已经存在就结束
            let snapshot = this.props.searchInfo.snapshotMap[
                this.state.status
            ].filter(item => item.visible !== false);
            let snapShot_list = tree2Array(snapshot);
            if (
                snapShot_list.find(
                    i => i.attrcode === this.state.moveNode.attrcode,
                )
            ) {
                return;
            }
        }
        if (
            this.props.onDropConditionEve &&
            this.props.onDropConditionEve.call(
                this.props._this._this,
                this.props.moduleId,
                this.state.moveNode.attrcode,
            )
        ) {
            return;
        }
        if (this.state.moveNode.hasOwnProperty('children')) {
            delete this.state.moveNode.children;
        }

        _addData.call(this, this.state.moveNode, this.state.status);
    };

    /* 清空值 */
    clearAdvValue = () => {
        isFunction(this.props.advSearchClearEve) &&
            this.props.advSearchClearEve(this.tabIndex);
        //同步内外的status
        this.props.searchInfo.status = this.state.status;
        this.state.addChecked = false;
        clearAllValue.call(this.props._this._this, this.props.moduleId);
    };
    clearAdvCurrentValue = () => {
        isFunction(this.props.advSearchClearCurrentEve) &&
            this.props.advSearchClearCurrentEve(this.tabIndex);
        //同步内外的status
        this.props.searchInfo.status = this.state.status;
        this.state.addChecked = false;
        clearAllValue.call(this.props._this._this, this.props.moduleId);
    };
    changeCheck = addChecked => {
        this.setState({ addChecked });
    };

    /* 修改查询方案名称 */
    // 修改名称项 不一定是当前项  editPlanName
    editSearchPlanName = (item, e) => {
        // e.stopPropagation()
        this.clickSearchPlan(item);
        this.planName = this.state.searchPlanName ||{}
        this.props.modal.show('editSearchPlanName@' + this.props.moduleId, {
            beSureBtnClick: () => {
                beSureBtnClick.call(
                    this.props._this,
                    'edit',
                    false,
                    this.state.currentPlan,
                    this.planName || this.state.searchPlanName,
                    false,
                    this.state.sortField,
                    this,
                    undefined,
               
                );
            },
            cancelBtnClick: () => {
                this.planName = "";
                this.forceUpdate();
            },
        });
        this.forceUpdate();
    };

    /* 删除查询方案 */
    delSearchPlan = item => {
        this.clickSearchPlan(item);
        // this.state.currentPlan = item;
        promptBox({
            color: 'warning',
            zIndex: this.props.zIndex+60,
            hotKeyboard: true,
            title: this.multiLang['page-search-0031'],
            content: <div>{this.multiLang['page-search-0015']}</div>, // 提示内容,非必输
            beSureBtnName: this.multiLang['page-search-0009'], // 确定按钮名称, 默认为"确定",非必输
            cancelBtnName: this.multiLang['page-search-0010'],
            beSureBtnClick: beSureBtnClick_Del.bind(
                this.props._this,
                false,
                this.state.currentPlan.pk_ncc_queryscheme,
                this,
            ),
        });
    };

    addTreeSearchPlan = item => {
        console.log('添加新的树节点');
    };

    /* 点击查询方案 */
    clickSearchPlan = (item, e) => {
        const { state } = this;
        if (
            item.pk_ncc_queryscheme == this.state.currentPlan.pk_ncc_queryscheme
        ) {
            return;
        }
        item.renderobj4web &&
            item.renderobj4web.forEach(
                val => (val.advrequired = !!val.required),
            );
        state.currentPlan = item;
        
        if (Array.isArray(item.sortfield)) {
            //如果此时模板上新增或删除了某一个字段设置默认，还得进行一次过滤
            let finalSortField = [];
            let schemaSortField = item.sortfield;
            let metaSortfield = this.props.meta.sortField || [];
            let schemaSortObj = {};
            let metaSortObj = {};
            let newAddSortField = [];
            
            schemaSortField.forEach(item => {
                schemaSortObj[item.refcode] = item;
            });
            metaSortfield.forEach(item => {
                metaSortObj[item.refcode] = item;
            });
            schemaSortField.forEach(item => {
                if(Object.keys(metaSortObj).includes(item.refcode)){
                    finalSortField.push(item);
                }
            });

            metaSortfield.forEach(item => {
                if(!Object.keys(schemaSortObj).includes(item.refcode)){
                    newAddSortField.push(item);
                }
            });
            item.sortfield = [...finalSortField, ...newAddSortField];

            state.sortField = item.sortfield.map(i => {
                let _checked = i.ordertype === '0' ? false : i._checked ?? true;
                return { _checked, ...i };
            });
        } else if (Array.isArray(this.props.searchInfo.defaultPlan.sortField)) {
            state.sortField =
                this.props.searchInfo.defaultPlan.sortField.map(i => {
                    let _checked =
                        i.ordertype === '0' ? false : i._checked ?? true;
                    return { _checked, ...i };
                });
        } else {
            state.sortField = [];
        }

        // this.state.isDefaultPlan = item.pk_ncc_queryscheme == '001';
        // state.searchPlanName = item.name;
        // this.state.searchPlanMultiName = {
        //     name1:{value:item['name']},
        //     name2:{value:(item['name2'] ? item['name2'] : item['name'])},
        //     name3:{value:(item['name3'] ? item['name3'] : item['name'])}
        // };
        const name123 = this.props.searchInfo.multiLangOpt.createName123(item);
        state.searchPlanName = this.props.searchInfo.multiLangOpt.getMultiLangValueFromName123(name123);
        
        const extendsList = this.props.searchInfo.fixedConditionGroup;
        if (
            this.props.onlyShowSuperCondition ||
            (item.renderobj4web &&
                item.renderobj4web.length &&
                item.renderobj4web[0].refpk === 'root')
        ) {
            //高级
            state.status = 'super';
            this.props.searchInfo.status = 'super';
            let plan = { ...item };
            if (
                item.renderobj4web &&
                item.renderobj4web.length &&
                item.renderobj4web[0].refpk === 'root'
            ) {
                plan.renderobj4web = [...item.renderobj4web];
                plan.renderobj4web[0] = { ...item.renderobj4web[0] };
                plan.renderobj4web[0].children = [
                    ...extendsList,
                    ...item.renderobj4web[0].children,
                ];
            } else {
                plan.renderobj4web = [
                    {
                        attrcode: 'root',
                        refpk: 'root',
                        key: 'root',
                        operationSign: 'and',
                        children: _clone(item.renderobj4web),
                        noRemove: true, //不可移除
                        visible: true,
                    },
                ];
            }
            this.props.searchInfo.snapshotMap.super = spreadQueryPlan(
                this.props.context,
                plan.renderobj4web,
                this.props.searchInfo.itemsMap,
                this.props.searchInfo.isWidgetMode,
            );
        } else {
            //普通
            state.status = 'normal';
            this.props.searchInfo.status = 'normal';
            let plan = item.renderobj4web;
            if (item.pk_ncc_queryscheme == '001') {
                this.props.searchInfo.snapshotMap.normal = spreadQueryPlan(
                    this.props.context,
                    plan,
                    this.props.searchInfo.itemsMap,
                    this.props.searchInfo.isWidgetMode,
                );
            } else {
                let filterFix = Array.isArray(plan)
                    ? plan.filter(item => {
                        let fixCondition = extendsList.find(
                            a => a.attrcode == item.attrcode,
                        );
                        if (fixCondition) {
                            return false;
                        } else {
                            return true;
                        }
                    })
                    : [];
                this.props.searchInfo.snapshotMap.normal = spreadQueryPlan(
                    this.props.context,
                    [...extendsList, ...filterFix],
                    this.props.searchInfo.itemsMap,
                    this.props.searchInfo.isWidgetMode,
                );
            }
        }
        //同步内外状态
        isFunction(this.props.clickPlanEve) &&
            this.props.clickPlanEve(item, this.props._this._this);
        isFunction(this.props.setInitValueEvent) &&
            this.props.setInitValueEvent(this.state.status);
        isFunction(this.props.statusChangeEvent) &&
            this.props.statusChangeEvent(this.state.status);
        this.props.changePlanEve && this.props.changePlanEve(this.state.currentPlan.isMyPlan);
        this.setMyStateEve();
    };

    /* 创建查询方案dom */
    //各页签对应各自的查询展示方案，【他人分享的】查询方案再次请求接口返回
    //根据后端返回的创建用户来区分【我创建的】与【他人分享的】
    //更多图标按钮，【我创建的】页签下才会有，他人分享的方案无重命名/删除/分享功能(这不就意味着他人分享的方案没有更多按钮)
    createSearchPlan = () => {
        let { searchSchemaTab } = this.state;

        let newCache = this.props.searchInfo.searchPlanCache.filter(item => {
            let visible = item.visible === true || item.visible === undefined;
            if (searchSchemaTab === '2'){
                visible = visible && item.isMyPlan;
            }else if(searchSchemaTab === '3'){
                visible = visible && item.isshared;
            }
            return visible;
        });
        /*ajax*/
        if (!newCache.length) {
            // return (
            //     <li className="searchPlanList">
            //         <span className="searchPlanName">
            //             {this.multiLang['page-search-0029']}
            //         </span>
            //     </li>
            // );
            return <div className="empty-content" >
                <p className="empty"><i className="empty-icon"></i><span className="empty-text">{this.multiLang['page-search-0029']}</span></p>
            </div>;
        }

        return newCache.map(item => {
            let defaultDisPlay = this.props.meta.defaultDisPlay;
            if (defaultDisPlay === '00000000000000000000') {
                defaultDisPlay = '001';
            }
            let iconClass =
                item.pk_ncc_queryscheme ===
                (defaultDisPlay)
                    ? ' icon-def'
                    : '';

            //查询方案的显示与否，还需要个属性
            return (
                <li
                    className={`searchPlanList ${
                        this.state.currentPlan.pk_ncc_queryscheme == item.pk_ncc_queryscheme ? 'active' : ''
                    }`}
                    key={item.pk_ncc_queryscheme}
                >
                    <TipsTitle
                        title={item.labelName}
                        className="searchPlanName"
                        onTitleClick={this.clickSearchPlan.bind(this, item)}
                    ></TipsTitle>
                    {iconClass && this.props.runMode !== 'preview' && (
                        <i className="iconfont icon-default-hover icon-sheweimoren" />
                    )}

                    {/* 快速查询方案及他人分享的方案不显示'更多'图标 */}
                    <span className="searchPlanSet">
                        {!item.isshared &&
                            !item.isquickqs &&
                            item.isMyPlan &&
                            this.props.runMode !== 'preview' && (
                            <Dropdown
                                trigger={['hover']}
                                placement="bottomLeft"
                                delay={300}
                                overlay={
                                    //如果没有li就不要显示ul了，否则有样式问题
                                    <ul className="menu_items first_level">
                                        {this.props.runMode !==
                                                'preview' && (
                                            <li
                                                key="1"
                                                onClick={this.editSearchPlanName.bind(
                                                    this,
                                                    item,
                                                )}
        
                                                fieldid="searchPlanRename"
                                            >
                                                <span>{this.multiLang['page-search-0092'] || '重命名'}</span>
                                            </li>
                                        )}

                                        {/* 只有自己创建的方案才能够分享 */}
                                        {
                                            !this.props.hiddenShareBtn && (
                                                <li
                                                    key="2"
                                                    onClick={this.shareTransFerClick.bind(
                                                        this,
                                                        item,
                                                    )}
                                                    fieldid="searchPlanShare"
                                                >
                                                    <span>{this.multiLang['page-search-0124'] || '分享'}</span>
                                                </li>)
                                        }
                                        {this.props.runMode !==
                                                'preview' && (
                                            <li
                                                key="3"
                                                onClick={this.delSearchPlan.bind(
                                                    this,
                                                    item,
                                                )}
                                                fieldid="searchPlanDelete"
                                            >
                                                <span>{this.multiLang['page-search-0031'] || '删除'}</span>
                                            </li>
                                        )}
                                    </ul>
                                }
                            >
                                <span className="moreBtn">
                                    <i className="iconfont icon-gengduo" style={{ marginRight:'15px' }} />
                                </span>
                            </Dropdown>
                        )}

                        {/* {!item.isprepared &&
                            this.props.runMode !== 'preview' && (
                                <NCTooltip
                                    placement="top"
                                    overlay={this.multiLang['page-search-0092']} //重命名
                                    delayHide={1}
                                    delayShow={1000}
                                >
                                    <i
                                        className="iconfont searchPlanEdit icon-gerenpeizhi"
                                        onClick={this.editSearchPlanName.bind(
                                            this,
                                            item
                                        )}
                                    />
                                </NCTooltip>
                            )} */}
                        {/* {!item.isprepared &&
                            this.props.runMode !== 'preview' && (
                                <NCTooltip
                                    placement="top"
                                    overlay={
                                        this.multiLang[
                                            'page-search-icon-delete'
                                        ]
                                    }
                                    delayHide={1}
                                    delayShow={1000}
                                >
                                    <i
                                        className="iconfont searchPlanDel icon-shanchu"
                                        style={{
                                            marginRight: this.props
                                                .showAdvSetDefault
                                                ? '10px'
                                                : '0px',
                                        }}
                                        onClick={this.delSearchPlan.bind(
                                            this,
                                            item
                                        )}
                                    />
                                </NCTooltip>
                            )} */}
                        {this.props.showAdvSetDefault &&
                            this.props.runMode !== 'preview' && (
                            <NCTooltip
                                placement="top"
                                overlay={
                                    iconClass
                                        ? this.multiLang['page-search-0097']
                                        : this.multiLang['page-search-0095']
                                }
                                delayHide={1}
                                delayShow={1000}
                            >
                                <i
                                    className={
                                        'iconfont searchPlanDef icon-sheweimoren' +
                                            iconClass
                                    }
                                    onClick={e => {
                                        e.stopPropagation();
                                        if (iconClass) {
                                            return;
                                        }
                                        setDefaultScheme.call(
                                            this.props._this,
                                            true,
                                            item,
                                            item.pk_ncc_queryscheme,
                                            this.props.oid,
                                            item.pk_queryscheme_share,
                                        );
                                    }}
                                />
                            </NCTooltip>
                        )}
                    </span>
                </li>
            );
        });
    };

    /* 方案名称change事件 */
    searchPlanNameChange = (type, value, index) => {
        if(type == 'onchange'){
            this.planName  = value;
            // this.setState({ searchPlanName: value });
        }else if(type == 'onblur'){
            this.planName  = this.props.searchInfo.multiLangOpt.synchronousMultiLangValue(value, index);
            // this.setState({ searchPlanName: this.props.searchInfo.multiLangOpt.synchronousMultiLangValue(value, index) });
        }
        
    };

    /*修改表格中查询方案的名称 */
    modalTableContent = status => {
        let { selectedRowData } = this.state;
        const pk = selectedRowData?.values?.pk_ncc_queryscheme?.value;
        if(pk){
           
           const plan =  this.props.searchInfo.searchPlanCache.find(item=>item.pk_ncc_queryscheme===pk);
          const planName123 = this.props.searchInfo.multiLangOpt.createName123(plan);
           this.planName  = this.props.searchInfo.multiLangOpt.getMultiLangValueFromName123(planName123);

        }
        
        return (
            <div className="plan-content">
                <span className="label">
                    {this.multiLang['page-search-0012'] + ' '}
                </span>
                <span className="content">
                    <NCHotKeys>
                        
                        <NCMultiLangText
                            id='NC_searchPlanOutInput'
                            fieldid="NC_searchPlanModalTableText"
                            className="searchPlanModal"
                            attrcode="name"
                            languageMeta={this.props.context.languageMetas}
                            onChange={this.searchPlanNameChange.bind(this, 'onchange')}
                            maxlength={100}
                            id="NC_searchPlanModalInput"
                            onBlur={this.searchPlanNameChange.bind(this, 'onblur')}
                            // onSelect={this.handleSelect}
                            value={ this.planName}
                        />
                    </NCHotKeys>
                </span>
            </div>
        );
    };
    /* 修改方案模态框 */
    modalContent = status => {
        let checked = status === 'add';
    //    this.planName  =checked ? {}: JSON.parse(JSON.stringify(this.state.searchPlanName));
       if(this.props.hideSearchPlan){
        return null;
       }
        return (
            <div className="plan-content">
                <span className="label">
                    {this.multiLang['page-search-0012'] + ' '}
                </span>
                <span className="content">
                    <NCHotKeys
                        keyMap={{ high: ['enter'] }}
                        handlers={{ high: this.addSearchPlanClickEvent.bind(this, status) }}
                    >
                        <NCMultiLangText
                            id='NC_searchPlanOutInput'
                            fieldid="NC_searchPlanModalText"
                            className="searchPlanModal"
                            attrcode="name"
                            languageMeta={this.props.context.languageMetas}
                            onChange={this.searchPlanNameChange.bind(this, 'onchange')}
                            maxlength={100}
                            onBlur={this.searchPlanNameChange.bind(this, 'onblur')}
                            // onSelect={this.handleSelect}
                            value={ this.planName}
                        />
                    </NCHotKeys>
                </span>
                {checked && this.props.showAdvSetDefault && (
                    <div
                        className="setdefault"
                        onClick={() => {
                            this.setState({ checked: !this.state.checked });
                        }}
                    >
                        <NCCheckbox
                            checked={this.state.checked}
                            onClick={() => {
                                this.setState({ checked: !this.state.checked });
                            }}
                        />
                        <span className="default-lable">
                            {this.multiLang['page-search-0099']}
                        </span>
                    </div>
                )}
            </div>
        );
    };

    /* 修改查询方案内容模态框 */
    modifySearchContent = status => {
        return <div className="plan-content">mmmmmmmm</div>;
    };

    /* 新增查询方案内容模态框 */
    addSearchContent = status => {
        return <div className="plan-content">aaaaaaaa</div>;
    };

    /* 删除查询方案内容模态框 */
    delSearchContent = status => {
        return <div className="plan-content">dddddd</div>;
    };

    /* 共享方案内容模态框 */
    modalShareContent = status => {
        let checked = status === 'add';
        if(this.props.hideSearchPlan){
            return null
        }
        //整理方案共享表格数据

        console.log(this.props);
        return (
            <div className="share-plan-content">
                <div
                    onDragStart={e => {
                        e.stopPropagation();
                    }}
                    onDragOver={e => {
                        e.stopPropagation();
                    }}
                    onDragEnter={e => {
                        e.stopPropagation();
                    }}
                    onDrop={e => {
                        e.stopPropagation();
                    }}
                    style={{ height:'100%' }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <span style={{ display: 'inline-block' }}>
                            <NCTabs
                                fieldid="share_plan"
                                defaultActiveKey="1"
                                onChange={this.tabShareSchemaChange.bind(this)}
                                activeKey={this.state.shareSchemaTab}
                                className="searchTabStyle"
                            >
                                {
                                    <NCTabPane
                                        tab={
                                            <TipsTitle
                                                className="searchpane"
                                                title={this.multiLang[
                                                    'page-search-0127'
                                                ] || '全部'}
                                            ></TipsTitle>
                                        }
                                        key="1"
                                    ></NCTabPane>
                                }
                                {
                                    <NCTabPane
                                        tab={
                                            <TipsTitle
                                                className="searchpane"
                                                title={this.multiLang[
                                                    'page-search-0128'
                                                ] || 
                                                    '我创建的'
                                                }
                                            ></TipsTitle>
                                        }
                                        key="2"
                                    ></NCTabPane>
                                }
                                {
                                    <NCTabPane
                                        tab={
                                            <TipsTitle
                                                className="searchpane"
                                                title={this.multiLang[
                                                    'page-search-0129'
                                                ] ||
                                                    '他人分享的'
                                                }
                                            ></TipsTitle>
                                        }
                                        key="3"
                                    ></NCTabPane>
                                }
                            </NCTabs>
                        </span>
                        <span style={{ height: shareTableHeight + 'px', lineHeight: shareTableHeight + 'px' }}>
                            {this.state.shareSchemaTab === '2' && (
                                <NCButton
                                    onClick={() => {
                                        this.deleteSearchMange();
                                    }}
                                    shape="border"
                                    //colors="danger"
                                    className="secondary-button secondary-button-wrapper footer-button-left"
                                    fieldid="deleteMange"
                                    disabled={!this.state.shareTableChecked}
                                >
                                    {this.multiLang['page-search-0031'] || '删除'}
                                </NCButton>
                            )}

                            {this.state.shareSchemaTab === '2' && (
                                <NCButton
                                    onClick={async () => {
                                        //在这里获取已经分配的方案与当前选择的表格数据进行对比
                                        //若存在相同的方案分享，则提示弹窗,点完确定之后还是得弹出分享弹窗
                                        //否则，弹出分享弹窗
                                        //通过接口进行批量分享校验
                                        // this.checkBatchShare();
                                        // pk_ncc_queryscheme
                                        // let { readyShareSchema } = this.state;
                                        let curCheckedRows =
                                            this.props.shareTableFunc.getCheckedRows(
                                                'searchShareTable',
                                            );
                                        console.log(curCheckedRows);
                                        //查询方案主键pk_ncc_queryscheme
                                        // let pk_ncc_queryscheme = readyShareSchema.pk_ncc_queryscheme.value;
                                        let param = [];
                                        curCheckedRows.forEach(item => {
                                            param.push({
                                                pk_ncc_queryscheme:
                                                    item.data.values
                                                        .pk_ncc_queryscheme
                                                        .value,
                                            });
                                        });
                                        let url =
                                            '/nccloud/platform/templet/querySchemeShared.do';
                                        let sharedSchemaPks =
                                            await this.sendAjax(url, param);

                                        if (sharedSchemaPks.length > 0) {
                                            this.batchSearchMange(
                                                curCheckedRows,
                                                sharedSchemaPks,
                                            );
                                        } else {
                                            if (curCheckedRows.length >= 1) {
                                                this.shareSearchSchemaClick(
                                                    curCheckedRows,
                                                );
                                            }
                                        }
                                    }}
                                    shape="border"
                                    //colors="danger"
                                    className="secondary-button secondary-button-wrapper footer-button-left"
                                    fieldid="batchMange"
                                    disabled={!this.state.shareTableChecked}
                                >
                                    {this.multiLang['page-search-0126'] || '批量分享'}
                                </NCButton>
                            )}
                        </span>
                    </div>
                    {this.props.shareTableFunc.createCardTable(
                        'searchShareTable',
                        {
                            showCheck: true,
                            showIndex: true,
                            showSelectedNum: false,
                            hideMaxBtn: true,
                            cancelCustomRightMenu: true,
                            hideTableTabs: true,
                            high_selectable: { enable: false, //默认为true
                            },
                            addBlankCol:false,
                            // showIndex:false,
                            adaptionHeight:true,
                            customIndexParams :{ resizable: false },
                            onAfterEvent: (...params) => {
                                //表格编辑后,若当前行的默认方案修改为true,把其余表格行的默认方案置为false
                                //这里就是保持只有一个默认方案

                                if (params[2] === 'show_schema') {
                                    //方式①，只处理props中的searchPlanCache(这里的问题就是若在willReceiveProps中拼接新的searchPlanCache会被经常调用)
                                    //若每次从接口中去拿怕有问题
                                    //显示方案这里是不是得处理searchPlanCache以控制某些方案的显示隐藏
                                    //在这改可以影响上级组件中的searchPlanCache，但要注意willReceiveProps中对searchPlanCache的重置
                                    // this.props.searchInfo.searchPlanCache = this.props.searchInfo.searchPlanCache.slice(0,2);

                                    //这里的问题就是，删除完查询方案后，更新meta后，willReceiveProps不会被调用，导致页面不会立即渲染
                                    // const queryschemes = this.props.searchInfo.searchPlanCache.slice(0,2);
                                    // this.props.searchInfo.searchPlanCache = this.props.searchInfo.searchPlanCache.slice(0,2);
                                    // this.props._this.searchPlanCacheChange(queryschemes);

                                    let url =
                                        '/nccloud/platform/templet/setDisPlayQueryScheme.do';
                                    let param = {
                                        pk_ncc_queryscheme:
                                            params[6].values.pk_ncc_queryscheme
                                                .value,
                                        visible: params[3],
                                        pk_queryscheme_share:
                                            params[6].values
                                                .pk_queryscheme_share?.value,
                                    };
                                    this.sendAjax(url, param);
                                    //这里得设置查询方案的visible属性
                                    this.props.searchInfo.searchPlanCache.map(
                                        item => {
                                            if (
                                                item.pk_ncc_queryscheme ===
                                                params[6].values
                                                    .pk_ncc_queryscheme.value
                                            ) {
                                                item.visible = params[3];
                                            }
                                        },
                                    );

                                    this.props._this.searchPlanCacheChange(
                                        this.props.searchInfo.searchPlanCache,
                                    );

                                    //参考上版本的删除方案处理方式，双驱动，如下：
                                    // this.state.searchInfo.searchPlanCache = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != pk_ncc_queryscheme);
                                    // // 修改模板的查询方案
                                    // this.props.meta.queryschemes = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != '001');
                                } else if (params[2] === 'default_schema') {
                                    //显示方案这里是不是得处理searchPlanCache以控制某些方案的方案名称
                                    // this.props.searchInfo.searchPlanCache

                                    //点了默认方案后，调用图钉图标逻辑，把某查询方案设为默认方案的逻辑，需处理下item
                                    // setDefaultScheme.call(
                                    //     this.props._this,
                                    //     true,
                                    //     item,//看下表格行
                                    //     item.pk_ncc_queryscheme,
                                    //     this.props.oid
                                    // );

                                    //看下其他表格该列字段是否存在，若存在，把该行数据对应字段值置为false
                                    let rowDatas = params[9];
                                    let curRowIndex = params[5];
                                    this.props.shareTableFunc.setEditableByIndex(
                                        'searchShareTable',
                                        curRowIndex,
                                        'show_schema',
                                        false,
                                    );
                                    if (rowDatas) {
                                        //至少保留一个默认方案
                                        rowDatas.forEach((e, i) => {
                                            if (
                                                e.values &&
                                                e.values.default_schema &&
                                                e.values.default_schema.value &&
                                                curRowIndex !== i 
                                            ) {
                                                //更新表格某行数据,编辑后更新某行的数据
                                                e.values.default_schema.value = false;
                                                if(e.values && e.values.pk_ncc_queryscheme.value !== '001' && e.values.quick_schema.value === false){
                                                    this.props.shareTableFunc.setEditableByIndex(
                                                        'searchShareTable',
                                                        i,
                                                        'show_schema',
                                                        true,
                                                    );
                                                }
                                            } else if (
                                                curRowIndex === i &&
                                                e.values &&
                                                e.values.show_schema &&
                                                !e.values.show_schema.value
                                            ) {
                                                e.values.show_schema.value = true;
                                            }
                                        });
                                        this.props.shareTableFunc.updateTableData(
                                            'searchShareTable',
                                            { rows: rowDatas },
                                        );
                                    }

                                    setDefaultScheme.call(
                                        this.props._this,
                                        true,
                                        [],
                                        params[6].values.pk_ncc_queryscheme
                                            .value,
                                        this.props.oid,
                                        params[6].values.pk_queryscheme_share
                                            ?.value,
                                    );

                                    //设为默认的时候，如果该方案未设置显示，则需把该方案置为显示方案
                                    let url =
                                        '/nccloud/platform/templet/setDisPlayQueryScheme.do';
                                    let param = {
                                        pk_ncc_queryscheme:
                                            params[6].values.pk_ncc_queryscheme
                                                .value,
                                        visible: true,
                                        pk_queryscheme_share:
                                            params[6].values
                                                .pk_queryscheme_share?.value,
                                    };
                                    this.sendAjax(url, param);

                                    //这里得设置查询方案的visible属性
                                    this.props.searchInfo.searchPlanCache.map(
                                        item => {
                                            if (
                                                item.pk_ncc_queryscheme ===
                                                params[6].values
                                                    .pk_ncc_queryscheme.value
                                            ) {
                                                item.visible = true;
                                            }
                                        },
                                    );

                                    //用于切换表格时更新search
                                    this.props.meta.defaultDisPlay = params[6].values
                                        .pk_ncc_queryscheme.value;
                                    this.props.searchInfo.searchPlanCache.map(
                                        item => {
                                            if (
                                                item.pk_ncc_queryscheme ===
                                                params[6].values
                                                    .pk_ncc_queryscheme.value
                                            ) {
                                                item.isdefaultdisplay = true;
                                            } else {
                                                if (
                                                    item.isdefaultdisplay ===
                                                    true
                                                ) {
                                                    item.isdefaultdisplay = false;
                                                }
                                            }
                                        },
                                    );

                                    this.props._this.searchPlanCacheChange(
                                        this.props.searchInfo.searchPlanCache,
                                    );
                                } else if (params[2] === 'schema_name') {
                                    // let currentPlan =
                                    //     this.props.searchInfo.searchPlanCache.find(
                                    //         item =>
                                    //             item.pk_ncc_queryscheme ==
                                    //             params[6].values
                                    //                 .pk_ncc_queryscheme.value,
                                    //     );
                                    // //TODO:这里可能有问题
                                    // let searchPlanName = params[3];

                                    // // this.state.currentPlan = currentPlan;
                                    // // this.state.searchPlanName = searchPlanName;

                                    // beSureBtnClick.call(
                                    //     this.props._this,
                                    //     'edit',
                                    //     false,
                                    //     currentPlan,
                                    //     searchPlanName,
                                    //     false,
                                    //     this.state.sortField,
                                    //     this,
                                    // );
                                }

                                //显示方案、默认方案的编辑后
                                this.setState({ canEditNameId: '-1' });
                                console.log(params, '编辑后');
                            },
                            onBeforeEvent: (...params) => {
                                //如果是方案名称列，若没有点击重命名，编辑前直接return
                                //
                                let curCellData = params[3];
                                if (
                                    params[2] === 'default_schema' &&
                                    curCellData.value
                                ) {
                                    return false;
                                }
                                if (
                                    params[2] === 'sharer' ||
                                    (params[2] === 'schema_name' &&
                                        this.state.canEditNameId !==
                                            params[5].rowid)
                                ) {
                                    return false;
                                }

                                // if(params[2] === 'rowdrag' && (params[6].values.default_schema.value || params[6].values.pk_ncc_queryscheme.value === '001')){
                                //     return false;
                                // }
                                console.log(params, '编辑前');
                            },
                            selectedChange: () => {
                                if (
                                    this.props.shareTableFunc.getCheckedRows(
                                        'searchShareTable',
                                    ).length > 0
                                ) {
                                    this.setState({ shareTableChecked: true });
                                } else {
                                    this.setState({ shareTableChecked: false });
                                }
                            },
                            setCellClass: (
                                index,
                                record,
                                attrcode,
                                a,
                                b,
                                c,
                            ) => {
                                //拖拽样式，这样更新有点卡
                                // if(this.state.dragOverIndex === index){
                                //     return 'test-cell-setting-style';
                                // }
                            },
                            tableHead: () => {
                                return (
                                    <div>
                                        <NCButton
                                            onClick={() => {
                                                this.modifySearchMange();
                                            }}
                                            shape="border"
                                            //colors="danger"
                                            className="secondary-button secondary-button-wrapper footer-button-left"
                                            fieldid="modifyMange"
                                        >
                                            修改
                                        </NCButton>
                                        <NCButton
                                            onClick={() => {
                                                this.saveSearchMange();
                                            }}
                                            shape="border"
                                            //colors="danger"
                                            className="secondary-button secondary-button-wrapper footer-button-left"
                                            fieldid="saveMange"
                                        >
                                            保存
                                        </NCButton>
                                        <NCButton
                                            onClick={() => {
                                                this.deleteSearchMange();
                                            }}
                                            shape="border"
                                            //colors="danger"
                                            className="secondary-button secondary-button-wrapper footer-button-left"
                                            fieldid="deleteMange"
                                        >
                                            删行
                                        </NCButton>
                                        <NCButton
                                            onClick={() => {
                                                this.batchSearchMange();
                                            }}
                                            shape="border"
                                            //colors="danger"
                                            className="secondary-button secondary-button-wrapper footer-button-left"
                                            fieldid="batchMange"
                                        >
                                            批量分享
                                        </NCButton>
                                    </div>
                                );
                            },
                            hideSwitch: () => {
                                return false;
                            },
                        },
                    )}
                    <div className='symbol-line'></div>
                    {/** 修改方案名称表格弹窗 */}
                    {!isEmpty(this.multiLang) &&
                        this.props.modal.createModal(
                            'editTableSearchName@' + this.props.moduleId,
                            {
                                title: this.multiLang['page-search-0082'],
                                content: this.modalTableContent.call(this, 'edit'),
                                // beSureBtnClick: () => {
                                //     let params = this.state.selectedRowData;
                                //     //取当前已选数据
                                //     let currentPlan = this.props.searchInfo.searchPlanCache.find(
                                //         (item) =>
                                //             item.pk_ncc_queryscheme === params.values.pk_ncc_queryscheme.value
                                //     );
                                //     beSureBtnClick.call(
                                //         this.props._this,
                                //         'edit',
                                //         false,
                                //         currentPlan,
                                //         this.state.searchTablePlanName,
                                //         this.state.checked,
                                //         this.state.sortField,
                                //         this,
                                //         undefined,
                                //         this.state.searchTablePlanMultiName
                                //     );
                                //     if(this.state.searchTablePlanName !== ''){
                                //         this.props.shareTableFunc.setValByKeyAndIndex(
                                //             'searchShareTable',
                                //             params.values.numberindex.value - 1,
                                //             'schema_name',
                                //             {display:this.state.searchTablePlanName,value:this.state.searchTablePlanName}
                                //         );
                                //     }

                                //     // beSureBtnClick.call(
                                //     //     this.props._this,
                                //     //     'edit',
                                //     //     false,
                                //     //     this.state.currentPlan,
                                //     //     this.state.searchPlanName,
                                //     //     false,
                                //     //     this.state.sortField,
                                //     //     this,
                                //     //     undefined,
                                //     //     this.state.searchPlanMultiName
                                //     // );
                                // },
                                // cancelBtnClick: () => {
                                //     this.forceUpdate();
                                // },
                                leftBtnName: this.multiLang['page-search-0009'],
                                rightBtnName: this.multiLang['page-search-0010'],
                                zIndex: this.props.zIndex+60,
                                // onEntered: this.onInputFocus,
                                // size: 'sm',
                                height: 150,
                                minHeight: 150,
                                minWidth: 400,
                                width: 400,
                                className: 'search-modal',
                            },
                        )}
                </div>
                {this.props.modal.createModal(
                    'shareSearchSchema@' + this.props.moduleId,
                    {
                        title: <span>
                            <span style={{ fontSize:'14px' }}>{this.multiLang['page-search-0149'] || '查询方案分享'}</span>
                            <NCTooltip
                                delayShow={800}
                                delayHide={1}
                                inverse
                                overlay={
                                    this.multiLang[
                                        'page-search-0164'
                                    ] || '选择页签下的某个组织，表示把此查询方案分享给该组织下的所有用户；选择页签下的某个部门，表示把此查询方案分享给该部门中主职和兼职人员所关联的用户；勾选集团级共享，表示该查询方案全集团的用户均可见'
                                }
                                placement="top"
                            >
                                <span style={{ cursor: 'pointer', paddingRight:'8px', marginLeft:'4px' }} 
                                    onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        return;
                                    }}
                                    className={'shuomingmag'}>

                                    <i
                                        onMouseEnter={e => {
                                            e.target.classList.remove(
                                                'icon-shuoming1',
                                            );
                                            e.target.classList.add(
                                                'icon-shuoming2',
                                            );
                                        }}
                                        onMouseLeave={e => {
                                            e.target.classList.remove(
                                                'icon-shuoming2',
                                            );
                                            e.target.classList.add(
                                                'icon-shuoming1',
                                            );
                                        }}
                                        onMouseDown={e => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            return;
                                        }}
                                        className="iconfont icon-shuoming1"
                                    />
                                </span>
                            </NCTooltip>
                        </span>,
                        content: this.shareSchemaContent.call(this, 'share'),
                        // size: 'sm',
                        minHeight: 560,
                        minWidth: 1100,
                        width: 1100,
                        height: 560,
                        mask: 'static',
                        showMaxButton:true,
                        // headerRight: () => {
                        //     return <RefreshBtn onClick={() => {
                        //         console.log('trigger RefreshBtn click!!');
                        //         toast({ content: this.multiLang['page-search-0156'] || '刷新成功', color: 'success' });
                        //         // TODO 领域刷新逻辑
                        //     }} />;
                        // },
                        cancelBtnClick: () => {
                            this.setState({ checked: false });
                        },
                        closeModalEve: () => {
                            this.setState({ checked: false });
                        },
                        beSureBtnClick: () => {
                            this.saveSchemeShare();
                            //通过this.Child获取'集团级共享'的状态，再去请求接口
                            // ajax({
                            //     url: '/nccloud/riart/queryscheme/addQS.do',
                            //     async: true,//请求是否异步,等待接口返回数据后再执行
                            //     data: {},
                            //     success: res => {
                            //         if (res.success) {
                            //             toast({ content: multiLang['page-search-0119'], color: 'success' });
                            //         }
                            //     },
                            // });
                            // //树树穿梭框点击确定时，把已选的方案与分配谁更新state中的allocationInfo
                            // //如果是在表格中点击的分享，弹出树树穿梭框后，点确定后保存分配信息，点击表格的确定后再请求接口
                            // let selectedInfo = this.props.syncTree.getCheckedKeys(
                            //     'transferRight@' + this.props.moduleId
                            // );
                            // //记得去除树数据的根节点
                            // console.log('已选左树数据信息',selectedInfo);
                            //待分享的方案在readyShareSchema中存储

                            //自定义确定事件，看着beSureBtnClick里面做的事挺多的
                            // beSureBtnClick.call(
                            //     this.props._this,
                            //     'share',
                            //     false,
                            //     this.state.currentPlan,
                            //     this.state.searchPlanName,
                            //     this.state.checked,
                            //     this.state.sortField,
                            //     this
                            // )
                        },
                        leftBtnName: this.multiLang['page-search-0009'],
                        rightBtnName: this.multiLang['page-search-0010'],
                        zIndex: 251,
                        // onEntered: this.onInputFocus,
                        className: 'search-modal',
                    },
                )}
            </div>
        );
    };

    /* 共享方案底部模态框 */
    modalShareFooter = status => {
        let { value, foolValue } = this.state;
        return (
            <span style={{ display: 'inline-block', float: 'left' }}>
                <span style={{ display: 'inline-block' }}>
                    <Refer
                        placeholder={'参照'}
                        refName={'参照'}
                        type={'popover'}
                        refType={'grid'}
                        queryGridUrl={''}
                        value={value}
                        foolValue={foolValue}
                        onChange={(value, foolValue) => {
                            console.log(value, foolValue);
                            this.setState({
                                value,
                                foolValue,
                            });
                        }}
                        clickContainer={
                            <NCButton
                                shape="border"
                                //colors="danger"
                                className="secondary-button secondary-button-wrapper footer-button-left"
                                fieldid="savePlan"
                            >
                                集团共享
                            </NCButton>
                        }
                        isMultiSelectedEnabled={true}
                        checkStrictly={true}
                        fieldDisplayed={'refcode'}
                        fieldValued={'refpk'}
                    />
                </span>

                <span style={{ display: 'inline-block' }}>
                    <Refer
                        placeholder={'参照'}
                        refName={'参照'}
                        type={'popover'}
                        refType={'tree'}
                        queryTreeUrl={''}
                        value={value}
                        foolValue={foolValue}
                        onChange={(value, foolValue) => {
                            console.log(value, foolValue);
                            this.setState({
                                value,
                                foolValue,
                            });
                        }}
                        clickContainer={
                            <NCButton
                                shape="border"
                                //colors="danger"
                                className="secondary-button secondary-button-wrapper footer-button-left"
                                fieldid="savePlan"
                            >
                                集团共享
                            </NCButton>
                        }
                        isMultiSelectedEnabled={true}
                        checkStrictly={true}
                        fieldDisplayed={'refcode'}
                        fieldValued={'refpk'}
                    />
                </span>
                <NCButton
                    onClick={() => {
                        this.userAssignClick();
                    }}
                    shape="border"
                    //colors="danger"
                    className="secondary-button secondary-button-wrapper footer-button-left"
                    fieldid="savePlan"
                    style={{ marginBottom: '19px' }}
                >
                    用户共享
                </NCButton>
                <NCButton
                    onClick={() => {
                        this.dutyAssignClick();
                    }}
                    shape="border"
                    //colors="danger"
                    className="secondary-button secondary-button-wrapper footer-button-left"
                    fieldid="savePlan"
                    style={{ marginBottom: '19px' }}
                >
                    职责共享
                </NCButton>
                <NCButton
                    onClick={() => {}}
                    shape="border"
                    //colors="danger"
                    className="secondary-button secondary-button-wrapper footer-button-left"
                    fieldid="savePlan"
                    style={{ marginBottom: '19px' }}
                >
                    集团共享
                </NCButton>

                {this.props.modal.createModal(
                    'userAssign@' + this.props.moduleId,
                    {
                        title: '用户',
                        content: this.userAssignContent.call(
                            this,
                            'user',
                            this.props,
                        ),
                        // size: 'sm',
                        minHeight: 480,
                        minWidth: 800,
                        width: 800,
                        height: 480,
                        mask: 'static',
                        cancelBtnClick: () => {
                            this.setState({ checked: false });
                        },
                        closeModalEve: () => {
                            this.setState({ checked: false });
                        },
                        beSureBtnClick: () =>
                            //自定义确定事件，看着beSureBtnClick里面做的事挺多的
                            beSureBtnClick.call(
                                this.props._this,
                                'share',
                                false,
                                this.state.currentPlan,
                                this.state.searchPlanName,
                                this.state.checked,
                                this.state.sortField,
                                this,
                                undefined,

                            ),
                        leftBtnName: this.multiLang['page-search-0009'],
                        rightBtnName: this.multiLang['page-search-0010'],
                        zIndex: 311,
                        // onEntered: this.onInputFocus,
                        className: 'search-modal',
                    },
                )}
                {this.props.modal.createModal(
                    'dutyAssign@' + this.props.moduleId,
                    {
                        title: '职责',
                        content: this.dutyAssignContent.call(this, 'duty'),
                        // size: 'sm',
                        minHeight: 480,
                        minWidth: 800,
                        width: 800,
                        height: 480,
                        mask: 'static',
                        cancelBtnClick: () => {
                            this.setState({ checked: false });
                        },
                        closeModalEve: () => {
                            this.setState({ checked: false });
                        },
                        beSureBtnClick: () =>
                            beSureBtnClick.call(
                                this.props._this,
                                'share',
                                false,
                                this.state.currentPlan,
                                this.state.searchPlanName,
                                this.state.checked,
                                this.state.sortField,
                                this,
                                undefined,
                  
                            ),
                        leftBtnName: this.multiLang['page-search-0009'],
                        rightBtnName: this.multiLang['page-search-0010'],
                        zIndex: 311,
                        // onEntered: this.onInputFocus,
                        className: 'search-modal',
                    },
                )}
            </span>
        );
    };

    /* 用户分配内容模态框 */
    userAssignContent = (status, propsparams) => {
        let { readyShareSchema, searchRight } = this.state;

        return (
            <div className="plan-content" style={{ height: '100%' }}>
                <UserAssignContent
                    syncTree={this.props.syncTree}
                    asyncTree={this.props.asyncTree} //同步树方法
                    readyShareSchema={readyShareSchema}
                    searchRight={searchRight}
                    multiLang={this.multiLang}
                />
            </div>
        );
    };

    handleAllocationInfo = info => {
        this.setState({ allocationInfo: info });
    };

    /* 方案共享模态框 */
    shareSchemaContent = status => {
        let { readyShareSchema, searchRight } = this.state;
        return (
            <div className="plan-content" style={{ height: '100%' }}>
                <UserAssignContent
                    updateAllocation={info => {
                        this.handleAllocationInfo(info);
                    }}
                    readyShareSchema={readyShareSchema}
                    onRef={node => (this.Child = node)}
                    searchRight={searchRight}
                    multiLang={this.multiLang}
                    {...this.props}
                />
            </div>
        );
    };

    /* 职责分配内容模态框 */
    dutyAssignContent = status => {
        return (
            <div className="plan-content">
                {/* <DutyAssignContent />
                 */}
                <span>safklasf</span>
            </div>
        );
    };

    clearRquiredWraning = item => {
        let status = this.props.searchInfo.status;
        if (item) {
            PubSub.publish('clearWarning_' + this.props.moduleId, {
                data: item.attrcode,
                status,
                moduleId: this.props.moduleId,
            });
        }
    };

    // 生成查询条件单元
    createDomItem = (snapshotItem, status) => {
        let templetItem = this.props.searchInfo.itemsMap[snapshotItem.attrcode];
        let initialvalue = snapshotItem.initialvalue;
        let renderItem = this.props.renderItem;
        if (!templetItem) {
            return null;
        } else {
            // 通过api设置值
            if (status === this.props.searchInfo.status) {
                if (initialvalue.value) {
                    if (Array.isArray(initialvalue.value)) {
                        if (initialvalue.value[0] || initialvalue.value[1]) {
                            this.clearRquiredWraning(templetItem);
                        }
                    } else if (templetItem.itemtype === 'refer') {
                        initialvalue.display &&
                            this.clearRquiredWraning(templetItem);
                    } else {
                        this.clearRquiredWraning(templetItem);
                    }
                } else if (!templetItem.required) {
                    this.clearRquiredWraning(templetItem);
                }
            }
            let dom = new templateEngine({
                searchPlanNum: this.state.currentPlan.pk_ncc_queryscheme,
                moduleId: this.props.moduleId,
                searchInfo: this.props.searchInfo,
                snapshotItem,
                isAdvDom: true,
                onAfterEvent: this.props.onAfterEvent,
                onBeforeEvent: this.props.onBeforeEvent,
                setStateEve: this.setStateEve,
                renderItem,
                context: this.props.context,
                showRequire: false,
                showPlaceholder: true,
                hiddenFunList: this.props.hiddenFunList,
                multiLang: this.multiLang,
                LangData: this.LangData,
                status: status,
                containerRef: this.containerRef.current,
            });
            return (
                <SearchItem
                    areaId={this.props.moduleId}
                    key={
                        this.props.searchInfo.currentPlan.pk_ncc_queryscheme +
                        (snapshotItem.refpk || snapshotItem.attrcode)
                    }
                    name={snapshotItem.refpk || snapshotItem.attrcode}
                    itemtype={templetItem.itemtype}
                    status={status}
                    // limit={count}
                    // sortFlag={sortFlag}
                    fieldid={getSysFieldid(snapshotItem.attrcode)}
                    className="search-item-wrap"
                    dom={dom}
                    hotkeytag={`searchArea-${
                        snapshotItem.refpk || snapshotItem.attrcode
                    }`}
                />
            );
        }
    };

    /* 生成查询条件 */
    createDom = status => {
        let itemsMap = this.props.searchInfo.itemsMap;
        if (typeof status === 'string') {
            var snapshot = this.props.searchInfo.snapshotMap[status].filter(
                item => item.visible !== false ,
            );
        } else if (typeof status === 'object') {
            var snapshot = status.filter(item => item.visible);
        }
        if (!snapshot.length) {
            return;
        }
        let snapshot_list = tree2Array(snapshot);
        
        let searchDisabled = this.props.searchInfo.searchDisabled;
        snapshot_list.forEach(element => {
            if (element.visible !== false) {
                let operationOptions = createOperation(
                    itemsMap[element.attrcode].queryOperateType,
                );
                if (operationOptions.length > 0) {
                    if (
                        !operationOptions.some(
                            i => element.operationSign === i.value,
                        )
                    ) {
                        element.operationSign =
                            (operationOptions[0] &&
                                operationOptions[0].value) ||
                            element.operationSign ||
                            '=';
                        // element.initialvalue = { display: '', value: '' };
                    }
                    element.operationOptions = operationOptions;
                }
            }
        });
        if (snapshot_list.length === 0) {
            return null;
        }
        return snapshot
            .map((data, ind) => {
                //  必输项标识
                let item = this.props.searchInfo.itemsMap[data.attrcode];
                if (!item && !data.attrcode.includes('root')) {
                    return null;
                }
                let mustFillIn = null;
                if (item && !data.remove && item.required) {
                    mustFillIn = (
                        <div className="mustFillIn iconfont icon-xinghao"></div>
                    );
                }

                let searchChildDom = this.createDomItem(data, 'super');

                /* 树节点dom */
                const treeTitle = () => {
                    let logicOptions = {
                        and: this.multiLang['page-search-0035'],
                        or: this.multiLang['page-search-0036'],
                    };

                    if (data.children && data.children.length) {
                        const hasRequire = data.children.some(
                            item =>
                                this.props.searchInfo.itemsMap[item.attrcode] &&
                                this.props.searchInfo.itemsMap[item.attrcode]
                                    .required,
                            this,
                        );
                        return (
                            <div className="advancedSearchSign">
                                <div
                                    keys={JSON.stringify({
                                        attrcode: data.refpk,
                                        isExtend: !!data.isExtend,
                                    })}
                                    // field={data.refpk}
                                    className="advancedSearchChild"
                                    // onDrop={this.onDropChildren}
                                    // onDragOver={this.onDragOver}
                                >
                                    {data.attrcode === 'root' && hasRequire ? (
                                        <div className="advancedSearch_root">
                                            {logicOptions[data.operationSign]}
                                        </div>
                                    ) : (
                                        <div className="select-containter">
                                            <NCSelect
                                                className="NC_logicSign"
                                                showClear={false}
                                                listHeight={160}
                                                disabled={
                                                    searchDisabled === true
                                                        ? true
                                                        : false
                                                }
                                                // getPopupContainer={() => {
                                                //     return document.querySelector('.search-adv-scroll_area') || document.body;
                                                // }}
                                                value={String(
                                                    data.operationSign || 'and',
                                                )}
                                                onChange={this.logicSelectChange.bind(
                                                    this,
                                                    data,
                                                )}
                                                fieldid={data.attrcode}
                                            >
                                                {Object.keys(logicOptions).map(
                                                    (val, index) => {
                                                        return (
                                                            <NCOption
                                                                key={index}
                                                                value={String(
                                                                    val,
                                                                )}
                                                            >
                                                                {
                                                                    logicOptions[
                                                                        val
                                                                    ]
                                                                }
                                                            </NCOption>
                                                        );
                                                    },
                                                )}
                                            </NCSelect>
                                        </div>
                                    )}
                                </div>
                                {!data.noRemove && !data.isfixedcondition && (
                                    <span
                                        className="searchAdvCom_remove"
                                        onClick={this.removeDom.bind(
                                            this,
                                            data,
                                        )}
                                    >
                                        {this.multiLang['page-search-0037']}
                                    </span>
                                )}
                            </div>
                        );
                    } else {
                        if (data.operationOptions) {
                            let selectDom = (
                                <div
                                    className={'NC_searchAdvCom ' + data.refpk}
                                    // key={data.refpk}
                                    keys={JSON.stringify({
                                        attrcode: data.refpk,
                                        isExtend: !!data.isExtend,
                                    })}
                                    // onDrop={this.onDropChildren}
                                    // onDragOver={this.onDragOver}
                                >
                                    <span className="remove">
                                        {data.remove ? (
                                            <span
                                                className="searchAdvCom_remove"
                                                onClick={this.removeDom.bind(
                                                    this,
                                                    data,
                                                )}
                                            >
                                                <i className="iconfont icon-qingkong" />
                                            </span>
                                        ) : (
                                            <span className="searchAdvCom_remove"></span>
                                        )}
                                    </span>
                                    <span className="content">
                                        {mustFillIn}
                                        <TipsTitle
                                            tagType="div"
                                            className="searchAdvCom_name"
                                            title={item.advLable || item.label}
                                        ></TipsTitle>
                                        {/* <NCTooltip
                                        delayShow={800}
                                        delayHide={0}
                                        inverse
                                        overlay={<div>{item.advLable || item.label}</div>}
                                        placement="top"
                                    >
                                        <div className="searchAdvCom_name">{item.advLable || item.label}</div>
                                    </NCTooltip> */}

                                        <div className="searchAdvCom_select">
                                            {data.operationOptions.length >
                                            1 ? (
                                                    <NCSelect
                                                        className="NC_operateSign"
                                                        showClear={false}
                                                        listHeight={160}
                                                        // getPopupContainer={() => {
                                                        //     return document.querySelector('.search-adv-scroll_area') || document.body;
                                                        // }}
                                                        disabled={!!item.disabled}
                                                        value={String(
                                                            data.operationSign ||
                                                            this.multiLang[
                                                                'page-search-0035'
                                                            ],
                                                        )}
                                                        onChange={this.mathSignChange.bind(
                                                            this,
                                                            data,
                                                        )}
                                                        fieldid="operateSign"
                                                    >
                                                        {data.operationOptions.map(
                                                            (val, index) => {
                                                                return (
                                                                    <NCOption
                                                                        key={index}
                                                                        value={String(
                                                                            val.value,
                                                                        )}
                                                                    >
                                                                        {
                                                                            val.display
                                                                        }
                                                                    </NCOption>
                                                                );
                                                            },
                                                        )}
                                                    </NCSelect>
                                                ) : (
                                                    <TipsTitle
                                                        tagType="div"
                                                        className="option-label"
                                                        title={
                                                            (
                                                                data
                                                                    .operationOptions[0] ||
                                                            {}
                                                            ).display
                                                        }
                                                    ></TipsTitle>
                                                )}
                                        </div>
                                        <div className="searchAdvCom_com">
                                            {searchChildDom}
                                        </div>
                                        <div className="tuozhuai-icon iconfont icon-tuozhuai1"></div>
                                    </span>
                                </div>
                            );

                            return selectDom;
                        } else {
                            console.log('the data is', data);
                        }
                    }
                };

                if (data.children && data.children.length) {
                    let logicOptions = {
                        and: this.multiLang['page-search-0035'],
                        or: this.multiLang['page-search-0036'],
                    };
                    const children = data.children;
                    return (
                        <NCTreeNode
                            key={data.refpk}
                            title={treeTitle.call(this, data)}
                            className="search-right-area-tree-node"
                            liAttr={{
                                fieldid: getSysFieldid(
                                    logicOptions[data.operationSign] + '_node',
                                ),
                            }}
                        >
                            {this.createDom(children)}
                        </NCTreeNode>
                    );
                }

                return (
                    <NCTreeNode
                        key={data.refpk}
                        title={treeTitle.call(this, data)}
                        liAttr={{ fieldid: getSysFieldid(data.attrcode + '_node') }}
                        className={`search-right-area-tree-node${
                            this.state.status === 'super' ? ' child-node' : ''
                        }`}
                    />
                );
            })
            .filter(item => item);
    };

    createNormalDom = status => {
        let snapshot = this.props.searchInfo.snapshotMap[status].filter(
            item => item.visible !== false,
        );
        if (!snapshot.length) {
            return null;
        }
        let snapshot_list = tree2Array(snapshot);
        let meta = this.props.meta;
        let itemsMap = this.props.searchInfo.itemsMap;
        snapshot_list.forEach(element => {
            if (element.visible !== false) {
                let operationOptions = createOperation(
                    itemsMap[element.attrcode].queryOperateType,
                );
                if (operationOptions.length > 0) {
                    if (
                        !operationOptions.some(
                            i => element.operationSign === i.value,
                        )
                    ) {
                        element.operationSign =
                            (operationOptions[0] &&
                                operationOptions[0].value) ||
                            element.operationSign ||
                            '=';
                        // element.initialvalue = { display: '', value: '' };
                    }
                    element.operationOptions = operationOptions;
                }
            }
        });
        return snapshot.map((data, index) => {
            //  必输项标识
            let item = this.props.searchInfo.itemsMap[data.attrcode];
            // let isCheckboxOrRadio = item.itemtype === 'radio' || item.itemtype === 'checkbox';
            let isCheckboxOrRadio = true;
            if (!item) {
                return null;
            }
            let width = '100%';
            if (meta.columnnum === '2' && item.columnnum === '1') {
                width = '50%';
            }
            let mustFillIn = null;
            let searchChildDom = this.createDomItem(data, 'normal');
            if (item && !data.remove && item.required) {
                mustFillIn = (
                    <div className="mustFillIn iconfont icon-xinghao"></div>
                );
            }
            return (
                <div
                    className={'NC_searchAdvCom ' + data.refpk}
                    fieldid={getSysFieldid(data.attrcode + '_node')}
                    draggable={!this.props.dragForbidden}
                    pos={index}
                    key={data.refpk}
                    style={{ width: width }}
                    keys={JSON.stringify({
                        attrcode: data.refpk,
                        isExtend: !!data.isExtend,
                    })}
                    onDragStart={this.onNormalDragStart}
                    onDragOver={this.onNormalDragOver}
                    onDragLeave={this.onNormalDragLeave}
                    onDragEnd={this.onNormalDragEnd}
                    onDrop={this.onNormalDrop.bind(this)}
                >
                    <div
                        className="remove"
                        onClick={this.removeNormalDom.bind(this, data, index)}
                    >
                        {data.remove ? (
                            <i className="iconfont icon-qingkong" />
                        ) : (
                            <div></div>
                        )}
                    </div>
                    <span className="content">
                        {mustFillIn}
                        <TipsTitle
                            tagType="div"
                            className="searchAdvCom_name"
                            title={item.advLable || item.label}
                        ></TipsTitle>
                        {/* <NCTooltip
                        delayShow={800}
                        inverse
                        delayHide={0}
                        overlay={<div>{item.advLable || item.label}</div>}
                        placement="top"
                    >
                        <div className="searchAdvCom_name">{item.advLable || item.label}</div>
                    </NCTooltip> */}

                        <div className="searchAdvCom_select">
                            {data.operationOptions.length > 1 ? (
                                <NCSelect
                                    className="NC_operateSign"
                                    showClear={false}
                                    listHeight={160}
                                    disabled={!!item.disabled}
                                    // getPopupContainer={() => {
                                    //     return document.querySelector('.search-adv-scroll_area') || document.body;
                                    // }}
                                    value={String(
                                        data.operationSign ||
                                            this.multiLang['page-search-0035'],
                                    )}
                                    onChange={this.mathSignChange.bind(
                                        this,
                                        data,
                                    )}
                                    fieldid="operateSign"
                                >
                                    {data.operationOptions.map((val, index) => {
                                        return (
                                            <NCOption
                                                key={index}
                                                value={String(val.value)}
                                            >
                                                {val.display}
                                            </NCOption>
                                        );
                                    })}
                                </NCSelect>
                            ) : (
                                <TipsTitle
                                    tagType="div"
                                    className="option-label"
                                    title={
                                        (data.operationOptions[0] || {}).display
                                    }
                                ></TipsTitle>
                            )}
                        </div>
                        <div className="searchAdvCom_com">{searchChildDom}</div>
                        <div className="tuozhuai-icon iconfont icon-tuozhuai1"></div>
                    </span>
                </div>
            );
        });
    };

    /* 移除控件 */
    removeDom = data => {
        if (data.remove === false) {
            return;
        }
        const { status, snapshotMap, searchDisabled } = this.props.searchInfo;
        if (searchDisabled === true) {
            return;
        }
        const queryconditionCount = snapshotMap[status].filter(
            item => item.attrcode === data.attrcode,
        ).length;
        if (
            !this.props.removeQuerConditionEve ||
            !this.props.removeQuerConditionEve.call(
                this.props._this._this,
                this.props.moduleId,
                data.attrcode,
                queryconditionCount,
            )
        ) {
            this.state.targetKey = null;
            delNode.call(
                this.props._this._this,
                this.props.moduleId,
                data.refpk,
            );
        }
    };
    removeNormalDom = (data, index) => {
        if (data.remove === false) {
            return;
        }
        const { status, snapshotMap, searchDisabled } = this.props.searchInfo;
        if (searchDisabled === true) {
            return;
        }
        const queryconditionCount = snapshotMap[status].filter(
            item => item.attrcode === data.attrcode,
        ).length;
        if (
            !this.props.removeQuerConditionEve ||
            !this.props.removeQuerConditionEve.call(
                this.props._this._this,
                this.props.moduleId,
                data.attrcode,
                queryconditionCount,
            )
        ) {
            snapshotMap[status] = snapshotMap[status].filter(item => item.visible).filter((item, _index) => _index != index);
            this.forceUpdate();
        }
    };
    onDragEnterBox = () => {
        this.state.targetKey = null;
    };
    onSuperDragEnter = info => {
        let { event, node, expandedKeys, dropPosition } = info;
        let enterKey = node.props.eventKey;
        this.setState({ expandedKeys: new Set(this.state.expandedKeys) });
        if (this.willExpendKey === enterKey) {
            return;
        } else {
            clearTimeout(this.willExpendKeyTimeout);
        }
        console.log('onSuperDragEnter', event, node, expandedKeys);
        this.willExpendKey = enterKey;
        if (
            !this.state.expandedKeys.has(enterKey) &&
            enterKey.endsWith('root')
        ) {
            this.willExpendKeyTimeout = setTimeout(() => {
                this.setState({
                    expandedKeys: new Set([
                        ...this.state.expandedKeys,
                        this.willExpendKey,
                    ]),
                });
            }, 500);
        }
    };

    onSuperDragEnd = () => {
        console.log('onSuperDragEndonSuperDragEndonSuperDragEnd');
        this.willExpendKey = null;
        clearTimeout(this.willExpendKeyTimeout);
    };

    //找到tree的指定层级
    treeSearch = (tree, pos) => {
        if (pos.length === 2) {
            return tree;
        }
        let treeNode = tree[0].children;
        for (let index = 2; index < pos.length - 1; index++) {
            const level = pos[index];
            treeNode = treeNode[level].children;
        }
        return treeNode;
    };

    onSuperDrop = info => {
        this.onSuperDragEnd();
        const { searchInfo } = this.props;
        const { status, snapshotMap, itemsMap } = searchInfo;
        const snapshot = snapshotMap[status];
        let { event, node, dragNode } = info;
        let target = event.dataTransfer.getData('attrcode');
        let { dragOver, dragOverGapBottom, dragOverGapTop, pos } = node.props;
        let posArr = pos.split('-');
        let treeNode = this.treeSearch(snapshot, posArr);
        let item = treeNode[posArr[posArr.length - 1]];
        let ITEM = itemsMap[item.attrcode];
        let newTime = new Date().getTime();
        //表示从左边往右边拖
        if (target !== '') {
            let result = this.checkedDrag(target);
            if (result === false) {
                return;
            }
            let _items = itemsMap[target];
            let data = initData(_items, true);
            data.isExtend = false;
            data.refpk = newTime + data.refpk;
            //表示合并,分为两种情况
            if (dragOver) {
                // 可能是逻辑节点
                if (ITEM) {
                    if (ITEM.required && !item.remove) {
                        toast({
                            content: this.multiLang['page-search-0058'],
                            color: 'warning',
                        });
                        return false;
                    } else if (ITEM.isfixedcondition) {
                        toast({
                            content: this.multiLang['page-search-0091'],
                            color: 'warning',
                        });
                        return false;
                    } else if (ITEM.nodelete) {
                        toast({
                            content: this.multiLang['page-search-0103'],
                            color: 'warning',
                        });
                        return false;
                    }
                }
                if (
                    item.attrcode.split('@')[1] === 'root' ||
                    item.attrcode === 'root'
                ) {
                    item.children.unshift(data);
                    this.setState({
                        expandedKeys: new Set([
                            ...this.state.expandedKeys,
                            item.refpk,
                        ]),
                    });
                } else {
                    let newPk = newTime + '@' + 'root';
                    item.refpk = newTime + item.refpk;
                    let newTree = {
                        attrcode: newPk,
                        refpk: newPk,
                        key: newPk,
                        operationSign: 'and',
                        children: [data, item],
                        visible: true,
                    };
                    treeNode[posArr[posArr.length - 1]] = newTree;
                    this.setState({
                        expandedKeys: new Set([
                            ...this.state.expandedKeys,
                            newPk,
                        ]),
                    });
                }
            } else if (dragOverGapBottom) {
                //表示放在下面
                if (item.refpk === 'root') {
                    return false;
                }
                treeNode.splice(1 + Number(posArr[posArr.length - 1]), 0, data);
            } else if (dragOverGapTop) {
                //表示放在上面
                if (item.refpk === 'root') {
                    return false;
                }
                treeNode.splice(posArr[posArr.length - 1], 0, data);
            }
        } else {
            let {
                dragOver: _dragOver,
                dragOverGapBottom: _dragOverGapBottom,
                dragOverGapTop: _dragOverGapTop,
                pos: _pos,
            } = dragNode.props;
            let _posArr = _pos.split('-');
            let _treeNode = this.treeSearch(snapshot, _posArr);
            let _item = _treeNode[_posArr[_posArr.length - 1]];
            let _ITEM = itemsMap[_item.attrcode];
            //拷贝一个
            let itemCopy = { ..._item };
            let parentTreeNode;
            let parentItem;
            if (_treeNode.length === 1) {
                let arr = [..._posArr].splice(0, _posArr.length - 1);
                parentTreeNode = this.treeSearch(snapshot, arr);
                parentItem = parentTreeNode[arr[arr.length - 1]];
            }
            if (dragOver) {
                //可能是逻辑节点
                if (ITEM) {
                    if (ITEM.required && !item.remove) {
                        toast({
                            content: this.multiLang['page-search-0058'],
                            color: 'warning',
                        });
                        return false;
                    } else if (ITEM.isfixedcondition) {
                        toast({
                            content: this.multiLang['page-search-0091'],
                            color: 'warning',
                        });
                        return false;
                    } else if (ITEM.nodelete) {
                        toast({
                            content: this.multiLang['page-search-0103'],
                            color: 'warning',
                        });
                        return false;
                    }
                }
                if (_ITEM && item.refpk !== 'root') {
                    if (_ITEM.required && !_item.remove) {
                        toast({
                            content: this.multiLang['page-search-0058'],
                            color: 'warning',
                        });
                        return false;
                    } else if (_ITEM.isfixedcondition) {
                        toast({
                            content: this.multiLang['page-search-0091'],
                            color: 'warning',
                        });
                        return false;
                    } else if (_ITEM.nodelete) {
                        toast({
                            content: this.multiLang['page-search-0103'],
                            color: 'warning',
                        });
                        return false;
                    }
                }
                if (
                    item.attrcode.split('@')[1] === 'root' ||
                    item.attrcode === 'root'
                ) {
                    item.children.unshift(itemCopy);
                    this.setState({
                        expandedKeys: new Set([
                            ...this.state.expandedKeys,
                            item.refpk,
                        ]),
                    });
                } else {
                    let newPk = newTime + '@' + 'root';
                    let newTree = {
                        attrcode: newPk,
                        refpk: newPk,
                        key: newPk,
                        operationSign: 'and',
                        children: [itemCopy, item],
                        visible: true,
                    };
                    treeNode[posArr[posArr.length - 1]] = newTree;
                    this.setState({
                        expandedKeys: new Set([
                            ...this.state.expandedKeys,
                            newPk,
                        ]),
                    });
                }
            } else if (dragOverGapBottom) {
                if (posArr.length > _posArr.length && _item.remove === false) {
                    toast({
                        content: this.multiLang['page-search-0107'],
                        color: 'warning',
                    });
                    return false;
                }
                if (item.refpk === 'root') {
                    return false;
                }
                treeNode.splice(
                    1 + Number(posArr[posArr.length - 1]),
                    0,
                    itemCopy,
                );
            } else if (dragOverGapTop) {
                if (posArr.length > _posArr.length && _item.remove === false) {
                    toast({
                        content: this.multiLang['page-search-0107'],
                        color: 'warning',
                    });
                    return false;
                }
                if (item.refpk === 'root') {
                    return false;
                }
                treeNode.splice(posArr[posArr.length - 1], 0, itemCopy);
            }
            //给item加一个标识 isDragging
            _item.isDragging = true;
            //移除标识元素
            // for (let index = 0; index < _treeNode.length; index++) {
            //     const ele = _treeNode[index];
            //     if (ele.isDragging) {
            //         _treeNode.splice(index--, 1);
            //         _item.isDragging = false;
            //         break;
            //     }
            // }
            // 改sonar问题，存一下旧方案
            for (let index = _treeNode.length - 1; index >= 0; index--) {
                const ele = _treeNode[index];
                if (ele.isDragging) {
                    _treeNode.splice(index, 1);
                    _item.isDragging = false;
                    break;
                }
            }
            if (Array.isArray(parentTreeNode)) {
                parentItem.isDragging = true;
                // for (let index = 0; index < parentTreeNode.length; index++) {
                //     const ele = parentTreeNode[index];
                //     if (ele.isDragging) {
                //         parentTreeNode.splice(index--, 1);
                //         break;
                //     }
                // }
                // 改sonar问题，存一下旧方案
                for (
                    let index = parentTreeNode.length - 1;
                    index >= 0;
                    index--
                ) {
                    const ele = parentTreeNode[index];
                    if (ele.isDragging) {
                        parentTreeNode.splice(index, 1);
                        break;
                    }
                }
            }
        }
        this.forceUpdate();
    };
    onDragStart = e => {
        console.log('onDragStart', e);
    };
    onDragOver = e => {
        e.preventDefault();
    };

    onNormalDragStart = e => {
        if( this.mouseDownOnInput){
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        let dropEle = e.currentTarget;
        let index = dropEle.getAttribute('pos');
        e.dataTransfer.setData('attrcode', index);
    };
    onNormalDragOver = throttle(e => {

        e.preventDefault();
        let target = e.currentTarget;
        let clientY = e.clientY;
        if (this.clientY && Math.abs(this.clientY - clientY) < 1) {
            return;
        }
        if (target && target.classList.contains('NC_searchAdvCom')) {
            console.log('onNormalDragOver');
            let rect = target.getBoundingClientRect();
            let { top, bottom } = rect;
            if (clientY - top < 10) {
                target.className = 'NC_searchAdvCom border-top';
            } else if (bottom - clientY < 10) {
                target.className = 'NC_searchAdvCom border-bottom';
            } else {
                target.className = 'NC_searchAdvCom';
            }
        }
        this.clientY = clientY;
    }, 100);
    onNormalDragLeave = e => {
        console.log('onNormalDragLeave');
        let currentTarget = e.currentTarget;
        if (currentTarget) {
            currentTarget.className = 'NC_searchAdvCom';
        }
    };
    onNormalDragEnd = e => {
        let borderTopEle = document.querySelector(
            '.NC_searchAdvCom.border-top',
        );
        if (borderTopEle) {
            borderTopEle.className = 'NC_searchAdvCom';
        }
        let borderBottomEle = document.querySelector(
            '.NC_searchAdvCom.border-bottom',
        );
        if (borderBottomEle) {
            borderBottomEle.className = 'NC_searchAdvCom';
        }
    };
    onNormalDrop = e => {
        e.stopPropagation();
        let dropEle = e.currentTarget;
        let target = e.dataTransfer.getData('attrcode');
        let index = Number(dropEle.getAttribute('pos'));
        const fixedCount = this.props.searchInfo.fixedConditionGroup.length;
        if(index < fixedCount){
            return;
        }//牛玉洁说固定条件区域不能调顺序；
        let position = 'middle';
        if (dropEle.classList.contains('border-top')) {
            position = 'top';
        } else if (dropEle.classList.contains('border-bottom')) {
            position = 'bottom';
        }
        console.log('onNormalDrop', target, index, position);
        if (target) {
            //在normal中添加数据
            if (Number.isNaN(Number(target))) {
                let checkDrag = this.checkedDrag(target);
                if (checkDrag === false) {
                    return;
                }
                if (position === 'bottom') {
                    index = index + 1;
                    this.addNormalDom(target, index);
                } else if (position === 'middle') {
                    this.onDoubleClick(target);
                } else if (position === 'top') {
                    this.addNormalDom(target, index);
                }
            } else {
                target = Number(target);
                if (position === 'bottom' && index + 1 === target) {
                    index = index + 1;
                } else if (position === 'top' && index - 1 === target) {
                    index = index - 1;
                }
                if (target !== index) {
                    if (position === 'bottom') {
                        index = index + 1;
                    }
                    this.moveNormalDom(target, index);
                }
            }
        }
        this.onNormalDragEnd();
    };

    onTableDragStart = e => {
        console.log('onTableDragStart', e);
        // e.preventDefault(); //不阻止默认行为，onDrop没法用
        let dropEle = e.currentTarget;
        let index = dropEle.getAttribute('pos');
        e.dataTransfer.setData('attrcode', index);
    };

    onTableDragEnd = e => {
        e.stopPropagation();
        let dropEle = e.currentTarget;
        let target = e.dataTransfer.getData('attrcode');
        let index = Number(dropEle.getAttribute('pos'));
        // console.log('onTableDragEnd', e);
        //隐藏标志占位线
        let sharePlanElement = document.querySelector('.share-plan-content');
        if(sharePlanElement){
            let symbolElement = sharePlanElement.querySelector('.symbol-line');
            if(symbolElement){
                symbolElement.style.display = 'none';
                symbolElement.style.top = 0 + 'px';
            }
        }
    };

    onTableDragOver = e => {
        const gapCount = this.props. searchPlanCache.filter(item => item.pk_ncc_queryscheme != '001' && item.isquickqs != true).length;
        e.preventDefault(); //不阻止默认行为，onDrop没法用
        // const position = 'top';
        let dropEle = e.currentTarget;
        let target = e.dataTransfer.getData('attrcode');
        let index = Number(dropEle.getAttribute('pos'));
        let sharePlanElement = document.querySelector('.share-plan-content');
        if(sharePlanElement){
            let symbolElement = sharePlanElement.querySelector('.symbol-line');
            if(symbolElement){
                // let topDistance = (index + 0) * shareTableHeight ;
                let topDistance = (index ) * 24 + 60;
                symbolElement.style.display = 'block';
                symbolElement.style.top = topDistance + 'px';
            }
        }
        // console.log('onTableDragOver', e);
        // this.setState({
        //     dragOverIndex: index,
        // });
    };

    // onTableDragLeave = (e) => {
    //     console.log('onTableDragLeave', e);
    // };

    onTableDrop = e => {
        e.stopPropagation();
        let dropEle = e.currentTarget;
        let startTarget = e.dataTransfer.getData('attrcode');
        let index = Number(dropEle.getAttribute('pos'));
        console.log('onTableDrop', e);
        if (startTarget != index) {
            //拖拽松手的时候，获取表格的所有行数据，并把拖拽起始行数据插入到拖拽松手时的位置，然后更新表格
        //若起始拖拽位置小于拖拽松手位置，在表格中先把起始位置元素删除，然后再split追加元素在松手位置-1
        //若其实拖拽位置大于拖拽松手位置，在表格中先把起始位置删除，然后再split追加元素在松手位置
        //若位置相同，不操作表格数据
        //还得获取已选数据，设置完表格数据后再设置表格勾选--selectRowsByIndex/getCheckedRows
            let curSelectedData =
        this.props.shareTableFunc.getCheckedRows('searchShareTable');
            //取出所有已选值的rowId
            let curSelectedId = [];
            //根据排序后表格取所有节点的pks
            let orderSearchPks = [];
            let orderSearchPlanCache = [];
            curSelectedData.forEach(e => curSelectedId.push(e.data.rowId));

            let curTableData =
                this.props.shareTableFunc.getAllData('searchShareTable').rows;
            if (startTarget < index) {
                let onDragRowData = curTableData.splice(startTarget, 1);
                curTableData.splice(index, 0, ...onDragRowData);
                this.props.shareTableFunc.setTableData('searchShareTable', { rows: curTableData });
            } else if (startTarget > index) {
                let onDragRowData = curTableData.splice(startTarget, 1);
                curTableData.splice(index, 0, ...onDragRowData);
                this.props.shareTableFunc.setTableData('searchShareTable', { rows: curTableData });
            }

            //根据所有的已选rowId设置表格的已选
            curTableData.forEach((e, index) => {
                if (curSelectedId.includes(e.rowId)) {
                    this.props.shareTableFunc.selectRowsByIndex(
                        'searchShareTable',
                        index,
                    );
                }
                orderSearchPks.push(e.values.pk_ncc_queryscheme.value);
                this.props.searchPlanCache.forEach(item => {
                    if (
                        item.pk_ncc_queryscheme ===
                        e.values.pk_ncc_queryscheme.value
                    ) {
                        orderSearchPlanCache.push(item);
                    }
                });
            });
            //拖拽完表格后也应该调整缓存searchCacheInfo的顺序及meta中的查询方案顺序
            this.props.searchInfo.searchPlanCache = orderSearchPlanCache;

            this.props._this.searchPlanCacheChange(orderSearchPlanCache);

            //根据pks调整现有searchPlanCache的顺序

            let url = '/nccloud/platform/templet/orderQueryScheme.do';
            let param = [];

            //调整之后的表格转为接口想要的参数
            let adjustedTableData = this.props.shareTableFunc
                .getAllData('searchShareTable')
                .rows.filter(
                    item =>
                        !item.values.default_schema.value &&
                    item.values.pk_ncc_queryscheme.value !== '001',
                );
            adjustedTableData.forEach((item, index) => {
                param.push({
                    pk_ncc_queryscheme: item.values.pk_ncc_queryscheme.value,
                    pk_queryscheme_user: item.values.pk_queryscheme_user.value,
                    pk_queryscheme_share: '',
                    visible: item.visible,
                    isshared: item.isshared,
                    schemeorder: index,
                });
            });
            this.sendAjax(url, param);
       
        }

    };

    addNormalDom = (target, index) => {
        const { status, snapshotMap, itemsMap } = this.props.searchInfo;
        const snapshot = snapshotMap[status];
        let _items = itemsMap[target];
        let data = initData(_items, true);
        data.isExtend = false;
        let newTime = new Date().getTime();
        data.refpk = data.refpk + '@' + newTime;
        snapshot.splice(index, 0, data);
        this.forceUpdate();
    };
    moveNormalDom = (target, index) => {
        const { status, snapshotMap } = this.props.searchInfo;
        const snapshot = snapshotMap[status];
        if (target > index) {
            //先去掉拖拽的那个
            let data = snapshot.splice(target, 1);
            snapshot.splice(index, 0, data[0]);
        } else {
            let endDom = snapshot.splice(index);
            let data = snapshot.splice(target, 1);
            snapshot.push(...data, ...endDom);
        }
        this.forceUpdate();
    };
    onStart = info => {
        let { event, node } = info;
        let attrcode = node.props.attrcode;
        console.log('onStart', attrcode);
        event.dataTransfer.setData('attrcode', attrcode);
    };
    onDragEnd = () => {
        console.log('onDragEnd');
    };
    onNormalContainerDrop = e => {
        const { status, snapshotMap } = this.props.searchInfo;
        const snapshot = snapshotMap[status];
        let dropEle = e.currentTarget;
        let target = e.dataTransfer.getData('attrcode');
        if (dropEle.classList.contains('normalList')) {
            if (Number.isNaN(Number(target))) {
                this.onDoubleClick(target);
            } else {
                this.moveNormalDom(Number(target), snapshot.length);
            }
        }
    };
    onDoubleClick = (target, info) => {
        const { status, snapshotMap } = this.props.searchInfo;
        const snapshot = snapshotMap[status];
        let result = this.checkedDrag(target, snapshot.length);
        if (result === false) {
            return;
        }
        if (status === 'super') {
            this.addSuperCondition(target);
        } else if (status === 'normal') {
            this.addNormalDom(target, snapshot.length);
            setTimeout(() => {
                let pk = snapshot[snapshot.length - 1].refpk;
                let selector = '[class="NC_searchAdvCom ' + pk + '"]';
                let ele = document.querySelector(selector);
                ele?.scrollIntoViewIfNeeded(false);
            }, 0);
        }
    };

    // clickAddIcon = target => {
    //     this.props.modal.show('addSearchSchema@' + this.props.moduleId);
    //     this.forceUpdate();
    // };
    // clickEditIcon = target => {
    //     this.props.modal.show('modifySearchSchema@' + this.props.moduleId);
    //     this.forceUpdate();
    // };
    // clickDelIcon = target => {
    //     this.props.modal.show('delSearchSchema@' + this.props.moduleId);
    //     this.forceUpdate();
    // };
    onIconClick = params => {
        let { e, item, iconType, treeData } = params;
        console.log(e, item, iconType, treeData);
        if (iconType === 'gerenpeizhi') {
            this.editSearchPlanName(item);
        } else if (iconType === 'shanchu') {
            this.delSearchPlan(item);
        } else if (iconType === 'sheweimoren') {
            e.stopPropagation();
            setDefaultScheme.call(
                this.props._this,
                true,
                item,
                item.pk_ncc_queryscheme,
                this.props.oid,
            );
        } else if (iconType === 'zenjia') {
            this.addTreeSearchPlan(item);
        }
    };

    checkedDrag = target => {
        const { onDropConditionEve, searchInfo, moduleId } = this.props;
        const { status, snapshotMap, itemsMap } = searchInfo;
        const snapshot = snapshotMap[status];
        let item = itemsMap[target];
        if (item.isdrag === false) {
            return false;
        }
        if (item.onlyOne === true) {
            //平铺方案，有过已经存在就结束
            let snapShot_list = tree2Array(snapshot);
            if (snapShot_list.find(i => i.attrcode === item.attrcode)) {
                return false;
            }
        }
        if (
            onDropConditionEve &&
            onDropConditionEve.call(
                this.props._this._this,
                moduleId,
                item.attrcode,
            )
        ) {
            return false;
        }
        return true;
    };
    onExpand = (a, b) => {
        console.log(a, b);
        this.setState({ expandedKeys: new Set(a) });
    };
    creatConditionUIDom = data => {
        return (
            <div
                id={this.props.moduleId}
                className="NC_searchAdvComBox"
                fieldid={getSysFieldid('advSearch_tree-area')}
                style={
                    isFunction(this.props.addAdvBody) ||
                    isFunction(this.props.addAdvBodyBottom)
                        ? {}
                        : { height: '100%' }
                }
            >
                <div
                    fieldid={getSysFieldid('advSearch_tree')}
                    className="advSearch_tree"
                >
                    {isFunction(this.props.addAdvBody) &&
                        this.props.addAdvBody()}
                    {data === 'super' && (
                        <div
                            className="superList"
                            onDrop={this.onSuperContainerDrop}
                            onDragOver={this.onDragOver}
                        >
                            <NCTree
                                // defaultExpandedKeys="root0"
                                expandedKeys={[...this.state.expandedKeys]}
                                showLine={true}
                                draggable={!this.props.dragForbidden}
                                dragDelayExpandTime={1000}
                                className="superTree"
                                onDrop={this.onSuperDrop}
                                onExpand={this.onExpand}
                                autoExpandParent={false}
                                onDragEnter={this.onSuperDragEnter}
                                onDragEnd={this.onSuperDragEnd}
                            >
                                {this.createDom(data)}
                            </NCTree>
                        </div>
                    )}
                    {data === 'normal' && (
                        <div
                            className="normalList"
                            onDragOver={this.onDragOver}
                            onDragEnter={this.onDragOver}
                            onDrop={this.onNormalContainerDrop}
                        >
                            {this.createNormalDom(data)}
                        </div>
                    )}
                    {isFunction(this.props.addAdvBodyBottom) &&
                        this.props.addAdvBodyBottom()}
                </div>
            </div>
        );
    };

    handleChange = value => {
        this.state.status = value;
        this.props.searchInfo.status = value;
        let statusChangeEvent = this.props.statusChangeEvent;
        statusChangeEvent && statusChangeEvent(this.state.status);
        this.setMyStateEve();
    };
    onSuperContainerDrop = e => {
        e.stopPropagation();
        const { status, snapshotMap } = this.props.searchInfo;
        const snapshot = snapshotMap[status];
        let dropEle = e.currentTarget;
        let target = e.dataTransfer.getData('attrcode');
        console.log(target);
        this.onDoubleClick(target);
    };
    addSuperCondition = target => {
        const { status, snapshotMap, itemsMap } = this.props.searchInfo;
        const snapshot = snapshotMap[status];
        let _items = itemsMap[target];
        let data = initData(_items, true);
        data.isExtend = false;
        let newTime = new Date().getTime();
        data.refpk = newTime + data.refpk;
        if (!snapshot.length) {
            snapshotMap[status] = [
                {
                    attrcode: 'root',
                    refpk: 'root',
                    operationSign: 'and',
                    noRemove: true, //不可移除
                    children: [data],
                    visible: true,
                },
            ];
        } else {
            snapshot[0].children.push(data);
            setTimeout(() => {
                let pk = data.refpk;
                let selector = '[class="NC_searchAdvCom ' + pk + '"]';
                let ele = document.querySelector(selector);
                ele?.scrollIntoViewIfNeeded(false);
            }, 0);
        }
        this.forceUpdate();
    };

    /* 默认右侧区域dom */
    defRightDom = () => {
        let searchStatus = this.state.status;
        if (this.props.onlyShowSuperCondition) {
            searchStatus = 'super';
        }
        
        let className = 'search-adv-scroll_area search_';
        if (typeof this.props.moduleId === 'string') {
            className = className + this.props.moduleId;
        }
        switch (searchStatus) {
            case 'super':
                className += ' superArea';
                break;
            case 'normal':
                className += ' normalArea';
                break;
            default:
                break;
        }
        let height = this.props.hideSearchType ? '100%' : 'calc(100% - 34px)';
        return (
            <div
                className="adv-right-area"
                id="adv-right-area"
                onDragStart={e => {
                    e.stopPropagation();
                }}
                onDragOver={e => {
                    e.stopPropagation();
                }}
                onDragEnter={e => {
                    e.stopPropagation();
                }}
                onDrop={e => {
                    e.stopPropagation();
                }}
            >
                {/* {isFunction(this.props.addAdvBody) && this.props.addAdvBody()} */}
                {!this.props.hideSearchType && (
                    <NCRadioGroup
                        selectedValue={searchStatus}
                        className="adv_radio_type"
                        onChange={this.handleChange.bind(this)}
                    >
                        <NCRadio value="normal">
                            {this.multiLang['page-search-0006']}
                        </NCRadio>
                        <NCRadio value="super">
                            {this.multiLang['page-search-0007']}
                        </NCRadio>
                    </NCRadioGroup>
                )}
                <div
                    className={className}
                    ref={this.containerRef}
                    // tinper-next-role="container"
                    id="advArea"
                    style={{ height: height, position: 'relative' }}
                >
                    {searchStatus === 'normal' &&
                        this.creatConditionUIDom('normal')}
                    {searchStatus === 'super' &&
                        this.creatConditionUIDom('super')}
                </div>
            </div>
        );
    };

    sortDataChange = newData => {
        this.setState({ sortField: newData });
    };
    //排序页签
    sortTabDom = () => {
        return (
            <SortTab
                multiLang={this.multiLang}
                data={this.state.sortField}
                sortDataChange={this.sortDataChange}
                searchInfo={this.props.searchInfo}
            ></SortTab>
        );
    };

    tabOnChange = e => {
        this.tabIndex = e;
        if (e !== '0' && e !== '1' && isFunction(this.props.addAdvTabs)) {
            let callback = this.props.addAdvTabs().find((item, index) => String(item.key) === e || String(index + 10) === e).callback;
            isFunction(callback) && callback();
        }
        this.setMyStateEve();
    };

    /* 创建右侧区域dom */
    //若显示多页签，这是不是得返回数组
    createRightDom = () => {
        let searchInfo = this.props.searchInfo;
        let multiLang = this.props.multiLang;
        let searchName, sortName;
        if (typeof multiLang['page-search-0025'] === 'string'){
            searchName = this.props.searchConditionName || multiLang['page-search-0025'];
        }
        if (typeof multiLang['page-search-0104'] === 'string') {
            sortName = multiLang['page-search-0104'];
        }
        let showSortTab = searchInfo.sortField.length > 0 ? true : false;
        let def = [];
        if (this.props.isShowDefalutPage) {
            def.push({
                key: '0',
                name: searchName,
                content: this.defRightDom(),
            });
        }
        if (showSortTab) {
            def.push({
                key: '1',
                name: sortName,
                content: this.sortTabDom(),
            });
        }
        if (isFunction(this.props.addAdvTabs)) {
            let customTabs = this.props.addAdvTabs() || [];
            //遍历一遍添加key
            customTabs.forEach((item, index) => (item.key = item.key || String(index + 10)));
            def = [...def, ...customTabs];
        }
        return def;
    };
    onInputFocus = () => {
        document.getElementById('NC_searchPlanModalInput').focus();
    };
    render() {
        this.multiLang = this.props.multiLang;
        this.LangData = this.props.LangData;
        setMultiLang(this.multiLang);
        return (
            <div className="modalBody">
                {/* 业务组替换高级面板的整个body区域时，不加载公共查询条件，只加载自定义条件 */}
                {isFunction(this.props.replaceAdvBody) &&
                    this.props.replaceAdvBody()}

                {!isFunction(this.props.replaceAdvBody) && (
                    <div className="modalBodyBox">
                        {!(
                            this.props.hideSearchCondition &&
                            this.props.hideSearchPlan
                        ) && (
                            <div
                                className="leftArea"
                                fieldid={getSysFieldid('left_area')}
                            >
                                <NCTabs
                                    fieldid="left"
                                    defaultActiveKey="1"
                                    onChange={this.tabChange.bind(this)}
                                    activeKey={this.state.leftTab}
                                    className="searchTabStyle"
                                >
                                    {!this.props.hideSearchCondition && (
                                        <NCTabPane
                                            tab={
                                                <TipsTitle
                                                    className="searchpane"
                                                    title={
                                                        this.multiLang[
                                                            'page-search-0004'
                                                        ]
                                                    }
                                                ></TipsTitle>
                                            }
                                            key="1"
                                        ></NCTabPane>
                                    )}
                                    {!this.props.hideSearchPlan && (
                                        <NCTabPane
                                            tab={
                                                <TipsTitle
                                                    className="searchpane"
                                                    title={
                                                        this.multiLang[
                                                            'page-search-0005'
                                                        ]
                                                    }
                                                ></TipsTitle>
                                            }
                                            key="2"
                                        >
                                            {' '}
                                        </NCTabPane>
                                    )}
                                </NCTabs>
                                {/* {this.state.leftTab === '1' && <TemplateTree searchInfo={this.props.searchInfo} meta={this.props.meta}></TemplateTree>} */}
                                {this.state.leftTab === '1' &&
                                    this.props.syncTree.createSyncTree({
                                        treeId:
                                            'searchCondition@' +
                                            this.props.moduleId,
                                        showLine: true,
                                        neverDisable: true,
                                        expandedKeys: ['root'],
                                        onDoubleClickEve: this.onDoubleClick,
                                        // metaId:'treeForm',  // 树模板的id
                                        needEdit: false, //是否需要编辑节点功能，默认为true,可编辑；false：不可编辑
                                        draggable: !this.props.dragForbidden,
                                        onDragStartEve: this.onStart,
                                        onDragEndEve: this.onDragEnd,
                                        needDrop: false,
                                        searchType: 'filtration',
                                        nodeRightOpt: {
                                            icon: 'uf-triangle-right',
                                            callback: this.onClickRight,
                                        },
                                    })}
                                {/* {this.state.leftTab === '2' &&
                                    this.props.syncTree.createSyncTree({
                                        treeId:
                                            'searchSchema@' +
                                            this.props.moduleId,
                                        showLine: true,
                                        neverDisable: true,
                                        defaultExpandAll:true,
                                        // expandedKeys: ['root'],
                                        // onDoubleClickEve: this.onDoubleClick,
                                        // metaId:'treeForm',  // 树模板的id
                                        needEdit: true, //是否需要编辑节点功能，默认为true,可编辑；false：不可编辑
                                        draggable: true,
                                        // onDragStartEve: this.onStart,
                                        // onDragEndEve: this.onDragEnd,
                                        // needDrop: false,
                                        searchType: 'filtration',
                                        // nodeRightOpt: {
                                        //     icon: 'uf-triangle-right',
                                        //     callback: this.onClickRight,
                                        // },
                                        clickAddIconEve: this.clickAddIcon,
                                        clickEditIconEve: this.clickEditIcon,
                                        clickDelIconEve: this.clickDelIcon,
                                        showModal: false,
                                        customizeIconClick: this.onIconClick,
                                    })} */}

                                {this.state.leftTab === '2' && (
                                    <React.Fragment>
                                        <span>
                                            <NCTabs
                                                fieldid="plan"
                                                defaultActiveKey="1"
                                                onChange={this.tabSearchSchemaChange.bind(
                                                    this,
                                                )}
                                                activeKey={
                                                    this.state.searchSchemaTab
                                                }
                                                className="searchTabStyle searchPlanTabStyle"
                                            >
                                                {
                                                    <NCTabPane
                                                        tab={
                                                            <TipsTitle
                                                                className="searchpane"
                                                                title={this.multiLang[
                                                                    'page-search-0127'
                                                                ] || '全部'}
                                                            ></TipsTitle>
                                                        }
                                                        key="1"
                                                    ></NCTabPane>
                                                }
                                                {
                                                    <NCTabPane
                                                        tab={
                                                            <TipsTitle
                                                                className="searchpane"
                                                                title={this.multiLang[
                                                                    'page-search-0128'
                                                                ] || 
                                                                    '我创建的'
                                                                }
                                                            ></TipsTitle>
                                                        }
                                                        key="2"
                                                    ></NCTabPane>
                                                }
                                                {
                                                    !this.props.hiddenShareBtn && <NCTabPane
                                                        tab={
                                                            <TipsTitle
                                                                className="searchpane"
                                                                title={this.multiLang[
                                                                    'page-search-0129'
                                                                ] ||
                                                                    '他人分享的'
                                                                }
                                                            ></TipsTitle>
                                                        }
                                                        key="3"
                                                    ></NCTabPane>
                                                }
                                            </NCTabs>
                                            {
                                                !this.props.hiddenShareBtn && 
                                                <NCTooltip
                                                    delayShow={800}
                                                    // delayHide={1}
                                                    inverse
                                                    overlay={this.multiLang['page-search-0116'] || '查询方案管理'}
                                                    placement="top"
                                                >
                                                    <i
                                                        className="iconfont icon-cxxiugai"
                                                        style={{
                                                            position: 'absolute',
                                                            left: '212px',
                                                            bottom: '381px',
                                                            cursor: 'pointer',
                                                            display: 'inline-block',
                                                            height: '16px',
                                                            lineHeight: '15px',
                                                            width: '16px',
                                                            fontSize:'18px',
                                                        }}
                                                        onClick={() => {
                                                            this.shareSearchPlanClick();
                                                        }}
                                                    ></i>
                                                </NCTooltip>
                                            }

                                        </span>
                                        <ul className="searchPlanUl">
                                            {this.state.searchSchemaTab ===
                                                '1' && this.createSearchPlan()}
                                            {this.state.searchSchemaTab ===
                                                '2' && this.createSearchPlan()}
                                            {this.state.searchSchemaTab ===
                                                '3' && this.createSearchPlan()}
                                        </ul>
                                    </React.Fragment>
                                )}
                            </div>
                        )}

                        <div
                            className="rightArea"
                            // tinper-next-role="container"
                            fieldid={getSysFieldid('rigit_area')}
                            style={{
                                overflow: isFunction(
                                    this.props.replaceRightBody,
                                )
                                    ? 'auto'
                                    : 'hidden',
                                position: 'relative',
                            }}
                        >
                            {isFunction(this.props.replaceRightBody) &&
                                this.props.replaceRightBody()}
                            
                            {!isFunction(this.props.replaceRightBody) && this.tabIndex === '0' && <div className='ext-tab-right'>
                                {this.props.showAddSearchResult && (
                                    <NCCheckbox
                                        className="add-search-result"
                                        checked={this.state.addChecked}
                                        onChange={this.changeCheck}
                                    >
                                        {this.multiLang['page-search-0106']}
                                    </NCCheckbox>
                                )}
                                {this.props.showClearBtn && (
                                    <span
                                        className="clearData"
                                        onClick={this.clearAdvValue}
                                    >
                                        {this.multiLang['page-search-0017']}
                                    </span>
                                )}
                                {this.props.showClearCurrentBtn && (
                                    <span
                                        className="clearData"
                                        onClick={this.clearAdvCurrentValue}
                                    >
                                        {this.multiLang['page-search-0162']}
                                    </span>
                                )}
                            </div>}
                            {!isFunction(this.props.replaceRightBody) && (
                                <NCTabs
                                    className="searchTabStyle"
                                    onChange={this.tabOnChange.bind(this)}
                                    activeKey={this.tabIndex || '0'}
                                >
                                    {this.createRightDom().map(({ name, key, content }) => {
                                        return (
                                            <NCTabPane tab={name} key={key}>
                                                {content}
                                            </NCTabPane>
                                        );
                                    }, this)}
                                </NCTabs>
                            )}
                            {/* {!isFunction(this.props.replaceRightBody) && this.createRightDom()[Number(this.tabIndex || '0')]['content']} */}
                        </div>
                    </div>
                )}
                {/** 修改方案名称弹窗 */}
                {!isEmpty(this.multiLang) &&
                    this.props.modal.createModal(
                        'editSearchPlanName@' + this.props.moduleId,
                        {
                            title: this.multiLang['page-search-0082'],
                            content: this.modalContent.call(this, 'edit'),
                            leftBtnName: this.multiLang['page-search-0009'],
                            rightBtnName: this.multiLang['page-search-0010'],
                            zIndex: this.props.zIndex+60,
                            // onEntered: this.onInputFocus,
                            // size: 'sm',
                            height: 150,
                            minHeight: 150,
                            minWidth: 400,
                            width: 400,

                            className: 'search-modal',
                        },
                    )}
                {/** 另存新方案弹窗 */}
                {!isEmpty(this.multiLang) &&
                    this.props.modal.createModal(
                        'addSearchPlan@' + this.props.moduleId,
                        {
                            title: this.multiLang['page-search-0081'],
                            content: this.modalContent.call(this,'add'),
                            // size: 'sm',
                            minHeight: 180,
                            minWidth: 400,
                            width: 400,
                            height: 180,
                            // mask: 'static',
                            leftBtnName: this.multiLang['page-search-0009'],
                            rightBtnName: this.multiLang['page-search-0010'],
                            zIndex: this.props.zIndex+60,
                            // onEntered: this.onInputFocus,
                            className: 'search-modal',
                        },
                    )}
                {/** 共享方案弹窗 */}
                {!isEmpty(this.multiLang) &&
                    this.props.modal.createModal(
                        'shareSearchPlan@' + this.props.moduleId,
                        {
                            title:
                                this.multiLang['page-search-0116'] ||
                                '查询方案管理',
                            content: this.modalShareContent.call(this, 'share'),
                            // addLeftBtn: this.modalShareFooter.call(
                            //     this,
                            //     'share'
                            // ),
                            // size: 'sm',
                            minHeight: 476,
                            minWidth: 800,
                            width: 800,
                            height: 476,
                            mask: 'static',
                            noFooter: true,
                            cancelBtnClick: () => {
                                this.setState({ checked: false });
                            },
                            closeModalEve: () => {
                                this.setState({ checked: false });
                            },
                            beSureBtnClick: () => {
                                //表格下方的确定按钮控制表格中方案的重命名、设置默认方案、设置方案显示的保存，改完后还是得给后端
                                //这一步相当于方案的修改操作
                                //注意：分享/批量分享的具体分享也在这个确定按钮实现，穿梭框处的确定按钮只是把分享数据带过来
                                beSureBtnClick.call(
                                    this.props._this,
                                    'edit',
                                    false,
                                    this.state.currentPlan,
                                    this.state.searchPlanName,
                                    false,
                                    this.state.sortField,
                                    this,
                                    undefined,
                                 
                                );
                            },

                            leftBtnName: this.multiLang['page-search-0009'],
                            rightBtnName: this.multiLang['page-search-0010'],
                            zIndex: this.props.zIndex,
                            // onEntered: this.onInputFocus,
                            className: 'share-search-modal',
                            // resizable:false
                        },
                    )}
                {/** 修改查询方案弹窗 */}
                {/* {this.props.modal.createModal(
                    'modifySearchSchema@' + this.props.moduleId,
                    {
                        title: '修改查询方案',
                        content: this.modifySearchContent.call(this, 'modify'),
                        // size: 'sm',
                        minHeight: 180,
                        minWidth: 400,
                        width: 400,
                        height: 180,
                        mask: 'static',
                        cancelBtnClick: () => {
                            this.setState({ checked: false });
                        },
                        closeModalEve: () => {
                            this.setState({ checked: false });
                        },
                        beSureBtnClick: () =>
                            beSureBtnClick.call(
                                this.props._this,
                                'modify',
                                false,
                                this.state.currentPlan,
                                this.state.searchPlanName,
                                this.state.checked,
                                this.state.sortField,
                                this,
                                undefined,
                         
                            ),
                        leftBtnName: this.multiLang['page-search-0009'],
                        rightBtnName: this.multiLang['page-search-0010'],
                        zIndex: this.props.zIndex+60,
                        // onEntered: this.onInputFocus,
                        className: 'search-modal',
                    },
                )} */}

                {/** 新增查询方案弹窗 */}
                {/* {this.props.modal.createModal(
                    'addSearchSchema@' + this.props.moduleId,
                    {
                        title: '新增查询方案',
                        content: this.addSearchContent.call(this, 'add'),
                        // size: 'sm',
                        minHeight: 180,
                        minWidth: 400,
                        width: 400,
                        height: 180,
                        mask: 'static',
                        cancelBtnClick: () => {
                            this.setState({ checked: false });
                        },
                        closeModalEve: () => {
                            this.setState({ checked: false });
                        },
                        beSureBtnClick: () =>
                            beSureBtnClick.call(
                                this.props._this,
                                'add',
                                false,
                                this.state.currentPlan,
                                this.state.searchPlanName,
                                this.state.checked,
                                this.state.sortField,
                                this,
                                undefined,
                               
                            ),
                        leftBtnName: this.multiLang['page-search-0009'],
                        rightBtnName: this.multiLang['page-search-0010'],
                        zIndex: this.props.zIndex+60,
                        // onEntered: this.onInputFocus,
                        className: 'search-modal',
                    },
                )} */}

                {/** 删除查询方案弹窗 */}
                {/* {this.props.modal.createModal(
                    'delSearchSchema@' + this.props.moduleId,
                    {
                        title: '删除查询方案',
                        content: this.delSearchContent.call(this, 'del'),
                        // size: 'sm',
                        minHeight: 180,
                        minWidth: 400,
                        width: 400,
                        height: 180,
                        mask: 'static',
                        cancelBtnClick: () => {
                            this.setState({ checked: false });
                        },
                        closeModalEve: () => {
                            this.setState({ checked: false });
                        },
                        beSureBtnClick: () =>
                            beSureBtnClick.call(
                                this.props._this,
                                'del',
                                false,
                                this.state.currentPlan,
                                this.state.searchPlanName,
                                this.state.checked,
                                this.state.sortField,
                                this,
                                undefined,
                                
                            ),
                        leftBtnName: this.multiLang['page-search-0009'],
                        rightBtnName: this.multiLang['page-search-0010'],
                        zIndex: this.props.zIndex+60,
                        // onEntered: this.onInputFocus,
                        className: 'search-modal',
                    },
                )} */}

                {this.props.modal.createModal(
                    'shareTree@' + this.props.moduleId,
                    {
                        title: <span>
                            <span style={{ fontSize:'14px' }}>{this.multiLang['page-search-0149'] || '查询方案分享'}</span>
                            <NCTooltip
                                delayShow={800}
                                delayHide={1}
                                inverse
                                overlay={
                                    this.multiLang[
                                        'page-search-0164'
                                    ] || '选择页签下的某个组织，表示把此查询方案分享给该组织下的所有用户；选择页签下的某个部门，表示把此查询方案分享给该部门中主职和兼职人员所关联的用户；勾选集团级共享，表示该查询方案全集团的用户均可见'
                                }
                                placement="top"
                            >
                                <span style={{ cursor: 'pointer', paddingRight:'8px', marginLeft:'4px' }} 
                                    onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        return;
                                    }}
                                    className={'shuomingmag'}>

                                    <i
                                        onMouseEnter={e => {
                                            e.target.classList.remove(
                                                'icon-shuoming1',
                                            );
                                            e.target.classList.add(
                                                'icon-shuoming2',
                                            );
                                        }}
                                        onMouseLeave={e => {
                                            e.target.classList.remove(
                                                'icon-shuoming2',
                                            );
                                            e.target.classList.add(
                                                'icon-shuoming1',
                                            );
                                        }}
                                        onMouseDown={e => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            return;
                                        }}
                                        className="iconfont icon-shuoming1"
                                    />
                                </span>
                            </NCTooltip>
                        </span>,
                        content: this.shareSchemaContent.call(this, 'share'),
                        // size: 'sm',
                        minHeight: 560,
                        minWidth: 1100,
                        width: 1100,
                        height: 560,
                        mask: 'static',
                        showMaxButton:true,
                        headerRight: () => {
                            return <RefreshBtn onClick={() => {
                                console.log('trigger RefreshBtn click!!');
                                toast({ content: this.multiLang['page-search-0156'] || '刷新成功', color: 'success' });
                                // TODO 领域刷新逻辑
                            }} />;
                        },
                        cancelBtnClick: () => {
                            this.setState({ checked: false });
                        },
                        closeModalEve: () => {
                            this.setState({ checked: false });
                        },
                        beSureBtnClick: () => {
                            //树树穿梭框点击确定时，把已选的方案与分配谁更新state中的allocationInfo
                            //如果是在左侧查询方案处点击的分享，弹出树树穿梭框后，点确定就要请求接口
                            //获取弹窗shareSearchPlan@的显隐性，若不存在则点确定直接走后端接口
                            this.saveSchemeShare();
                            this.setState({ searchRight: false });
                        },

                        //自定义确定事件，看着beSureBtnClick里面做的事挺多的
                        // beSureBtnClick.call(
                        //     this.props._this,
                        //     'share',
                        //     false,
                        //     this.state.currentPlan,
                        //     this.state.searchPlanName,
                        //     this.state.checked,
                        //     this.state.sortField,
                        //     this
                        // ),
                        leftBtnName: this.multiLang['page-search-0009'],
                        rightBtnName: this.multiLang['page-search-0010'],
                        zIndex: 251,
                        // onEntered: this.onInputFocus,
                        className: `search-modal ${this.props.shareModalClassName || ""}`,
                    },
                )}
            </div>
        );
    }
}
